{
	"editQuizPage": {
		"incompatibleBrowserProfile": "The saved Web Browser configuration is unavailable for this assessment. Choose an available profile or platform before saving.",
		"chooseCompatiblePlatform": "Choose Configuration",
		"formAriaLabel": "Yuja Verity Proctoring Options Form",
		"setupProctoring": "Setup Proctoring",
		"failToSave": "Failed to save proctoring options.",
		"components": {
			"footer": {
				"back": "Back",
				"saveAsProfile": "Save as Profile",
				"confirm": "Confirm",
				"next": "Next",
				"cancel": "Cancel",
				"saveAsProfileTooltip": "Save the current proctoring configuration as a reusable profile for future assessments."
			},
			"selectAll": "Select All",
			"noResultsTitle": "No Matches Found",
			"noResultsDesc": "Try adjusting your search or filters to find results."
		},
		"thirdPartyAssessment": {
			"description": "Select the third-party platform for your assessment and enter the details.",
			"platformTitle": "Third-Party Platform",
			"platformDesc": "Select the platform of your third-party assessment.",
			"passwordSwitchTitle": "Password-Protected Assessment",
			"passwordSwitchDesc": "A password is required for your third-party assessment.",
			"urlTitle": "Third-Party Assessment URL",
			"urlDesc": "Enter the URL of the third-party platform where the assessment will be hosted.",
			"urlPlaceholder": "Enter third-party assessment URL",
			"yes": "Yes",
			"no": "No",
			"passwordTitle": "Assessment Password",
			"passwordDesc": "Enter the <b>exact password</b> created in your {{platform}} assessment. Verity will auto-fill it for test-takers to access their assessments.",
			"passwordPlaceholder": "Enter assessment password",
			"noPasswordWarning": "<b>Important</b>: If no password is set, test-takers may bypass Verity proctoring and access the assessment directly. We <b>highly recommend</b> setting up a password for your assessment in {{platform}} to ensure a secure proctored assessment.",
			"platformTooltip": "Not seeing this third-party integration? Please contact your admin to add it to Verity.",
			"platformPlaceholder": "Select option",
			"old": {
				"pleaseEnterNameAndURL": "Please enter a name for your assessment and add the URL and password provided by the third-party assessment tool.",
				"pleaseEnterURL": "Please enter the URL and password provided by the third-party assessment tool.",
				"nameUnchangeable": "The assessment name cannot be changed.",
				"nameLabel": "Assessment Name",
				"namePlaceholder": "Enter an assessment name",
				"urlLabel": "Assessment URL",
				"urlPlaceholder": "Enter a link to the assessment",
				"urlDisabled": "Please change the URL via your assessment's settings page.",
				"urlRequired": "This field is required.",
				"passwordLabel": "Assessment Password",
				"passwordPlaceholder": "Enter a password for the assessment",
				"httpsError": "URL must include http:// or https://",
				"domainError": "URL must have a top-level domain (e.g., .com)",
				"emptyError": "URL must not be empty",
				"spaceError": "URL must not include spaces",
				"slashError": "URL must not end in a slash",
				"validURL": "URL Valid"
			}
		},
		"platformStep": {
			"ariaLabel": "Learn more about our proctoring platforms (Opens in a new tab).",
			"allDisabled": "Your institution has disabled all proctoring platforms. Please contact your admin for assistance.",
			"extension": {
				"description": "The Browser Extension allows you to apply <b>standard proctoring measures</b>, which require test-takers to download the Verity Browser Extension.",
				"subtitle": "Supported Browsers",
				"chrome": "Chrome",
				"edge": "Edge",
				"brave": "Brave",
				"opera": "Opera",
				"firefox": "Firefox",
				"safari": "Safari"
			},
			"lockdown": {
				"description": "The Lockdown App allows you to apply <b>advanced proctoring measures</b>, which require test-takers to install Verity Lockdown on their devices.",
				"subtitle": "Supported Platforms",
				"windows": "Windows",
				"macOs": "MacOS"
			},
			"mobile": {
				"title": "Allow Mobile Lockdown App",
				"description": "Test-takers can complete the assessment on mobile devices.",
				"hint": "Not all proctoring measures are able to be applied on mobile devices."
			},
			"chromeOs": {
				"title": "Allow Chromebook Lockdown App",
				"description": "Test-takers can complete the assessment on Chromebooks.",
				"hintManagedGuestSession": "Test-takers on Chromebooks must be using a managed guest session to take this assessment as your institution admin has enforced Managed Guest Sessions.",
				"hintUnrestricted": "Not all proctoring measures are able to be applied on Chromebooks as your admin has not enforced Managed Guest Sessions. To enforce Managed Guest Sessions, please contact your Verity administrator."
			},
			"description": "Select the platform where test-takers will complete their assessment. <a>Learn more</a>.",
			"system": "(System)",
			"disabled": "(Disabled)",
			"browser": {
				"description": "Allows you to apply essential proctoring measures directly in the browser, with no applications or browser extensions required.",
				"subtitle": "Supported Browsers"
			}
		},
		"unsavedChanges": {
			"title": "Unsaved Changes",
			"ltiDescription": "Changes you have made will not be saved. Are you sure you want to leave?",
			"lmsDescription": "Your Verity proctoring settings will not be saved. Are you sure you want to leave?",
			"leaveButton": "Leave",
			"cancelButton": "Cancel"
		},
		"methodStep": {
			"description": "Select how test-takers will be monitored during their assessment.",
			"deleteUpcomingSessions": "Upcoming sessions must be deleted before turning off Live Proctoring. Past and in-progress sessions will not be affected.",
			"automated": {
				"header": "Automated Proctoring",
				"description": "AI proctors the assessment, delivering flagged results after the assessment.",
				"badge": "AI-Proctored"
			},
			"live": {
				"header": "Live Assessment",
				"description": "A live proctor monitors test-takers throughout the assessment.",
				"badge": "Human + AI-Proctored"
			},
			"liveCheckIn": {
				"header": "Live Check-In",
				"description": "AI proctors the assessment and alerts live proctors when issues are flagged.",
				"badge": "AI-Proctored + Check-In"
			},
			"postReview": {
				"header": "Live Check-In with Post-Assessment Review",
				"description": "Live Check-In plus manual review of recordings after each assessment.",
				"badge": "Live Check-In + Review"
			},
			"deleteModalTitle": "Delete Upcoming Sessions"
		},
		"liveSessionStep": {
			"description": "Create live assessment sessions that test-takers can register for by assigning them dates, times, and proctors.",
			"add": "Add",
			"addSession": "Add New Session",
			"expand": "More details",
			"collapse": "Hide details",
			"expandDisabled": "The session has ended and cannot be expanded.",
			"defaultName": "Session {{number}}",
			"delete": "Delete",
			"header": {
				"date": "Date",
				"duration": "Duration",
				"capacity": "Capacity",
				"capacityLabel": "{{capacity}} Max",
				"sessionNameTooltip": "The Name cannot be edited because the session has started.",
				"sessionNamePlaceholder": "Enter session name",
				"emptySessionName": "Enter a name for your session.",
				"actions": "Actions",
				"actionsDisabled": "Unable to access the menu. The session has started.",
				"standard": "Standard Session",
				"demo": "Demo Session",
				"multipleDates": "{{startDate}}, at {{startTime}} - {{endDate}}, at {{endTime}}",
				"oneDay": "{{startDate}} {{startTime}}-{{endTime}}"
			},
			"sessionDetails": {
				"title": "Session Details",
				"description": "Set the date, time, duration, capacity, and assign a proctor to monitor the session while test-takers complete it.",
				"startDateLabel": "Start Date & Time",
				"endDateLabel": "End Date & Time",
				"duration": "Duration",
				"sessionCapacity": "Session Capacity",
				"assignProctor": "Assign Proctor",
				"maxTestTakers": "test-takers maximum",
				"availabilityWarningInline": "Session time must be within exam availability window. Adjust start or end time accordingly.",
				"maximumDuration": "Maximum duration: {{duration}}",
				"totalDuration": "Duration:",
				"defaultProctor": "[No name]",
				"ariaLabels": {
					"startDateLiveSessionDialog": "Select start date for live session",
					"endDateLiveSessionDialog": "Select end date for live session",
					"slider": "Change duration of live session",
					"capacity": "Enter a capacity for the live session",
					"removeCapacity": "Decrease capacity by 1.",
					"addCapacity": "Increase capacity by 1."
				},
				"tooltip": {
					"capacity": "The Capacity cannot be edited because the session has started.",
					"demoStart": "The Start Date cannot be edited because the session has started.",
					"start": "The Date cannot be edited because the session has started.",
					"end": "The End Date cannot be edited because the session has started.",
					"duration": "The Duration cannot be edited because the session has started."
				},
				"error": {
					"demoStart": "Select a Start Date in the future.",
					"start": "Select a Start Date in the future.",
					"capacity": "Enter a Capacity of at least 1.",
					"dateOrderStart": "Select an Start Date that is before the End Date.",
					"end": "Select an End Date in the future.",
					"dateOrderEnd": "Select an End Date that is after the Start Date.",
					"timeOrder": "Select an End Date that is after the Start Date.",
					"duration": "Select a Duration of 7 days or less.",
					"durationTooLong": "Select a Duration of 7 days or less."
				}
			},
			"proctor": {
				"selectProctor": "Select Proctor",
				"noProctor": "A proctor must be selected.",
				"insufficientNotice": "This proctor group requires a {{count}}-hour notice before the start of the assessment.",
				"available": "Available",
				"unavailable": "Not Available"
			},
			"registrationWindow": {
				"title": "Registration Window",
				"description": "Test-takers can register at any time until the assignment starts. You can restrict registration to a specific time period.",
				"startDateAfterEndDate": "Start date cannot be after the end date.",
				"startDateAfterSessionStartDate": "Start date cannot be after the session start date.",
				"startDateRequired": "Start date is required.",
				"startDateMustBeFuture": "Select a Start Date in the future.",
				"endDateMustBeFuture": "Select an End Date in the future.",
				"endDateBeforeStartDate": "End date cannot be before the start date.",
				"endDateAfterSessionEndDate": "End date cannot be after the session end date.",
				"endDateRequired": "End date is required.",
				"endDateAfterCancellationTime_one": "End date must be earlier than the auto-cancellation period of your proctoring group. Please select {{count}} day before the session start date.",
				"endDateAfterCancellationTime_other": "End date must be earlier than the auto-cancellation period of your proctoring group. Please select {{count}} days before the session start date.",
				"ariaLabels": {
					"startDateDialog": "Select start date for registration window",
					"endDateDialog": "Select end date for registration window"
				}
			},
			"proctoringGuidelinesTitle": "Proctoring Guidelines",
			"proctoringGuidelinesDesc": "Add instructions and guidelines for proctors so they know what to expect.",
			"error": {
				"noLiveSessionMessage": "A live session must be created to continue.",
				"sessionIssueMessage": "The following sessions contain issues: {{sessionNames}}. Please check each session and resolve the issues to continue.",
				"sessionWarningMessage": "The following sessions contain warning messages: {{cancelledSessionNames}}.",
				"registrationTimesPast": "“{{sessionName}}” requires you to choose a registration date or time that has not already passed.",
				"alreadyEnded": "{{sessionName}} cannot be edited as it is currently in progress or has finished.",
				"timesPast": "The Start Time for {{sessionName}} has already passed. Please change it to a future time.",
				"minHoursNotice_one": "The proctoring group for {{sessionName}} cannot be applied. The group must be notified {{count}} hour before the start time.",
				"minHoursNotice_other": "The proctoring group for {{sessionName}} cannot be applied. The group must be notified {{count}} hours before the start time.",
				"insufficientNotice": "The proctoring group for {{sessionName}} does not have enough time to be notified.",
				"durationTooLong": "Select a Duration of 7 days or less for {{sessionName}}.",
				"proctorGuideTooBig": "The Proctor Guide section for {{sessionName}} exceeds the maximum size. Please try to reduce the size of images if applicable.",
				"default": "The settings for {{sessionName}} could not be applied. Please try again."
			},
			"durationFormat": {
				"day_one": "{{count}} day",
				"day_other": "{{count}} days",
				"day_short": "{{count}}d",
				"hour_one": "{{count}} hour",
				"hour_other": "{{count}} hours",
				"hour_short": "{{count}}h",
				"minute_one": "{{count}} minute",
				"minute_other": "{{count}} minutes",
				"minute_short": "{{count}}m"
			},
			"proctorModal": {
				"deleteTitle": "Delete Session",
				"confirmTitle": "Confirm Changes",
				"checkbox": "I understand and acknowledge the above statement."
			}
		},
		"accommodationStep": {
			"accommodationsHeader": "Accommodate test-takers by allowing them to take the assessment without proctoring or by modifying their proctoring configurations to suit their needs.",
			"accommodationsDisclaimer": "<b>Note</b>: Accommodated test-takers must still use Verity Lockdown or the Browser Extension, unless the instructor has selected No Proctoring.",
			"availableTestTakers": "Available Test-Takers",
			"testTaker": "Test-taker",
			"defaultName": "the test-taker",
			"accommodationStatus": "Accommodation Status",
			"noAccommodation": "No accommodation",
			"actionsHeader": "Actions",
			"actionsAriaLabel": "More actions",
			"selectedTestTakers_one": "{{count}} test-taker selected",
			"selectedTestTakers_other": "{{count}} test-takers selected",
			"updateAccommodation": "Update Accommodations",
			"removeAccommodation": "Remove Accommodations",
			"addAccommodation": "Add Accommodations",
			"filter": {
				"all": "All test-takers",
				"notAccommodated": "Not Accommodated",
				"notProctored": "Not Proctored",
				"modifiedProctoring": "Modified Proctoring",
				"ariaLabel": "Filter test-takers by accommodation status."
			},
			"accommodationsSaved_one": "The accommodation has been successfully applied to {{name}}.",
			"accommodationsSaved_other": "The accommodation has been successfully applied to the test-takers.",
			"viewDetailsDesc": "View the accommodation details and notes of the exempted test-taker.",
			"notProctored": "Not Proctored",
			"notProctoredTooltip": "No proctoring configurations will be applied to this test-taker. Verity Lockdown and the Browser Extension will not be required.",
			"modifiedProctoring": "Modified Proctoring",
			"modifiedProctoringTooltip": "{{profileName}} proctoring configuration has been applied to this test-taker.",
			"noAccommodationTooltip": "No accommodation profile has been added for this profile.",
			"searchPlaceholder": "Search by test-taker's name",
			"institutionToolTip": "You cannot remove the accommodations given to this test-taker by your institution.",
			"menu": {
				"add": "Add Accommodations",
				"view": "View Details",
				"edit": "Edit Accommodation",
				"remove": "Remove Accommodation"
			},
			"selectAll": "Select all test-takers",
			"unselectAll": "Unselect all test-takers",
			"accommodationDetails": "Accommodation Details",
			"closeButton": "Close",
			"unknownStudent": "Unknown Test-Taker",
			"selectStudent": "Select {{student}}",
			"unselectStudent": "Unselect {{student}}",
			"backButton": "Back to Review",
			"manageAccommodations": "Manage Accommodations"
		},
		"accommodationModal": {
			"description": "Choose the accommodation you would like to apply to the selected test-takers.",
			"setAccommodation": "Set Accommodation",
			"section1Header": "Select the accommodation you want to apply to the chosen test-takers.",
			"doNotProctorTitle": "Do Not Proctor",
			"doNotProctorLabel": "Remove all proctoring configurations for the selected test-takers. These test-takers will not be required to use Verity Lockdown or the Browser Extension.",
			"modifyTitle": "Modify Proctoring",
			"modifyLabel": "Apply an alternative set of proctoring configurations tailored to the selected test-takers.",
			"clearAccommodation": "Clear Accommodation",
			"addProfileHeader": "Add Profile",
			"addProfileLabel": "Choose a profile to apply its proctoring configurations to the test-takers.",
			"notesHeader": "Accommodation Notes (Optional)",
			"notesLabel": "Add notes explaining the accommodation. These notes can be reviewed in the Assessment Report.",
			"title": "Accommodate Test-Takers",
			"backButton": "Back to Manage Accommodations",
			"textFieldLabel": "Enter your accommodation notes",
			"saveAccommodations": "Save Accommodations"
		},
		"deleteProfileModal": {
			"cancel": "Cancel",
			"delete": "Delete",
			"title": "Delete Proctoring Profile",
			"titleShort": "Delete Profile",
			"success": "The proctoring profile has been successfully deleted.",
			"error": "The proctoring profile could not be deleted.",
			"text": "Are you sure you want to delete {{profileName}}? This proctoring profile will be permanently removed and cannot be recovered"
		},
		"configurationStep": {
			"description": "Select and configure the proctoring features for this assessment based on your security requirements.",
			"allDisabled": "Your institution has disabled all assessment restrictions. Please contact your admin for assistance.",
			"addExtensionModal": {
				"title": "Add Allowed Browser Extension",
				"description": "Enter the browser extension URL obtained from the Chrome Web Store. Learn more about <a>locating the extension URL</a>.",
				"inputTitle": "Extension URL",
				"inputPlaceholder": "Enter extension URL",
				"linkAriaLabel": "Learn more about locating the extension URL (opens in a new tab).",
				"idErrorMsg": "The browser extension URL is not valid. Please enter a valid URL.",
				"cancel": "Cancel",
				"add": "Add"
			},
			"addApplicationModal": {
				"title": "Add Application",
				"firstParagraph": {
					"block": "Enter the exact name of the application you want to block in the text box.",
					"allow": "Enter the exact name of the application you want to allow in the text box."
				},
				"secondParagraph": "<bold>Note:</bold> The application’s name should match the one that appears in the install directory on your device. Learn more about how to obtain the application’s name on your <windowsLink>Windows</windowsLink> or <macLink>Mac</macLink> device.",
				"osLinkAria": "Learn how to obtain application name for {{os}} device (opens in a new tab).",
				"applicationNameLabel": "Application Name: ",
				"cancel": "Cancel",
				"add": "Add"
			},
			"incognitoModal": {
				"ariaLabel": "Enabling Incognito Mode (opens in a new tab)",
				"link": "To learn how to allow Incognito mode, test-takers can follow our guide for <a>Enabling Incognito Mode</a>.",
				"title": "Incognito Requirement",
				"description": "Tab restrictions requires test-takers to allow the Verity Extension in Incognito mode to track tabs. Test-takers will need to enable Incognito mode for the Verity Extension to begin their assessment.",
				"ok": "Ok",
				"closeButtonAriaLabel": "Close dialog"
			},
			"geofenceModal": {
				"addTitle": "Add New Geofence Location",
				"addDescription": "Add a new location to limit where test-takers can take the assessment.",
				"editTitle": "Edit Geofence Location",
				"viewTitle": "View Geofence Location",
				"error": {
					"emptyName": "Enter a name for your geofence",
					"duplicateName": "Geofence name already in use",
					"invalidRadius": "Please select a radius between {{minRadius}} {{unit}} and {{maxRadius}} {{unit}}.",
					"noPermission": "Your location could not be detected. Please allow location access in your browser settings and try again.",
					"unknown": "Your location could not be determined. Please try again."
				},
				"locationLabel": "Location Name",
				"radius": "Radius",
				"radiusSliderLabel": "Adjust Radius",
				"radiusSliderDesc": "Select a radius between {{minRadius}} {{unit}} and {{maxRadius}} {{unit}}.",
				"save": "Save",
				"cancel": "Cancel",
				"add": "Add",
				"close": "Close",
				"metricUnit": "Meters",
				"imperialUnit": "Feet",
				"metricUnitShort": "m",
				"imperialUnitShort": "ft",
				"radiusWithUnit": "{{radius}} {{unit}}",
				"unitAriaLabel": "Select unit for radius",
				"manualLocation": "Manual Location",
				"unit": "Unit",
				"unitSelectAriaLabel": "Select unit"
			},
			"recordOptionsTSX": {
				"videoRecordingMode": {
					"faceTrackingMode": "<b>Detect Additional People</b> in the webcam view while the assessment is in progress.",
					"objectDetectionMode": "<b>Detect Suspicious Objects</b>, such as phones, within the test-taker’s environment.",
					"secondaryVideoRecordingMode": "<b>Require Secondary Camera</b> provides an additional angle of video coverage. Test-takers are required to have an additional camera or a mobile device as the secondary camera."
				},
				"quietEnviornment": "<b>Enable Quiet Environment</b> to notify the test-taker if their surroundings are too loud"
			},
			"verifyIdentityTSX": {
				"idVerificationEnableAi": {
					"label": "<b>Enable AI ID Verification</b> to automatically detect and verify the test-taker’s face and ID",
					"bypass": "Allow test-takers to take their assessment regardless of AI ID verification result"
				}
			},
			"disableFeaturesTSX": {
				"disableSystemClipboard": {
					"header": "Disable System Clipboard",
					"description": "If checked, the test-taker's clipboard will be disabled across all programs. Otherwise, it will only be disabled in webpages in Verity Lockdown."
				},
				"blockExtensions": {
					"addExtensions": "Add Allowed Extension",
					"allow-list": "Allowed Browser Extensions",
					"all": "Disable All Browser Extensions"
				},
				"rightClickPasswordConflictTxt": "The Disable Right Click feature cannot be enabled for assessments that require a password.",
				"blockApplications": {
					"modes": {
						"off": "Allow All Applications",
						"block-list": "Block Specific Applications",
						"allow-list": "Allow Specific Applications",
						"all": "Block All Applications"
					},
					"leastRestrictive": "Least Restrictive",
					"mostRestrictive": "Most Restrictive",
					"viewList": "View Apps"
				}
			},
			"otherActivitiesTSX": {
				"onlyOneScreen": "Only One Screen cannot be disabled when Block All Applications is selected in the Restrict Applications section.",
				"tabs": {
					"closeOpenTabs": "<b>Close Open Tabs</b> to ensure all tabs are closed before the assessment, allowing only permitted websites.",
					"disableNewTab": "<b>Disable New Tabs</b> to prevent test-takers from opening new tabs, except for permitted websites.",
					"recordWebTraffic": "<b>Record Web Traffic</b> to record websites accessed through the Verity browser extension, except for permitted websites."
				},
				"geofenceHint": "You can add geofences in Course Settings to save them for selection next time.",
				"keyboardList": "Keyboard Block List"
			},
			"showToolsTSX": {
				"calculator": {
					"standard": "Standard",
					"scientific": "Standard and Scientific",
					"subtitle": "Select the calculator that the test-taker will have access to.",
					"scientificTooltip": "Includes advanced functions such as trigonometry (sin, cos, tan), exponents, and logarithms."
				},
				"referenceMaterial": {
					"studentBannerTitle": "Important:",
					"studentBannerDesc": "Students will be required to upload their reference material before the assessment timer begins.",
					"subtitle": "Select who will provide the reference material for the assessment.",
					"radioBox": {
						"instructorLabel": "Instructors upload reference sheet",
						"studentLabel": "Students upload reference sheet"
					},
					"chooseFile": "Choose File",
					"toUpload": "to Upload",
					"fileTooLarge": "File too large. Max Size: 10MB.",
					"fileTooLargeDesc": "The file you are trying to upload exceeds the maximum size of 10MB. Please select a smaller file.",
					"invalidFileType": "Unsupported file type. Please upload a PDF, JPG, JPEG, or PNG file.",
					"noFile": "Please upload reference material to continue."
				}
			}
		},
		"editableListTSX": {
			"add": "Add",
			"save": "Save",
			"discard": "Discard",
			"delete": "Remove",
			"edit": "Edit",
			"actionsAriaLabel": "More actions",
			"editTextFieldAriaLabel": "Edit {{initialValue}}"
		},
		"tabWhiteListTSX": {
			"searchPlaceholder": "Enter website URL (e.g., https://example.com)",
			"addURL": "Add URL",
			"badgeText_one": "{{count}} website Allowed",
			"badgeText_other": "{{count}} websites Allowed",
			"title": "Add Permitted Websites",
			"description": "Add a list of permitted websites that test-takers can use as resources during the assessment.",
			"textFieldLabel": "Add URL",
			"deleteAriaLabel": "Remove {{name}} from approved website list.",
			"validUrl": "Valid URL",
			"hasDomain": "URL must include a top-level domain (e.g., .com, .edu, .ca)",
			"noSpaces": "URL must not include spaces",
			"hasHttp": "URL must start with http:// or https://",
			"pass": "Passed",
			"fail": "Failed"
		},
		"ipAddressListTSX": {
			"title": "IP Address Range",
			"description": "Enter the approved IP address range for this assessment.",
			"minLabel": "Start IP Address",
			"maxLabel": "End IP Address",
			"add": "Add IP Range",
			"rangeLabel": "{{min}} - {{max}}",
			"deleteAriaLabel": "Remove IP address range {{min}} to {{max}}."
		},
		"keyboardBlockList": {
			"title": "Add Shortcuts to Block",
			"description": "Add Keyboard Shortcuts to block during the examination.",
			"placeholder": "Type shortcut",
			"badgeText_one": "{{count}} Shortcut Blocked",
			"badgeText_other": "{{count}} Shortcuts Blocked",
			"textFieldLabel": "Add shortcut",
			"deleteAriaLabel": "Remove {{name}} from block list."
		},
		"blockedApplicationList": {
			"searchPlaceholder": "Search by application name",
			"filterLabel": "Filter applications",
			"selectAriaLabel": "Filter applications",
			"allow": {
				"badgeText_one": "{{count}} Application Allowed",
				"badgeText_other": "{{count}} Applications Allowed",
				"title": "Add Specific Applications to Allow",
				"description": "Select one or more applications from the list below that test-takers are <b>permitted to use</b> during the assessment.",
				"descriptionLink": "Select one or more applications from the list below that test-takers are <b>permitted to use</b> during the assessment. If an application is not listed, <a>Add New Applications</a>.",
				"note": "All applications not in the allowed applications list will be blocked during the assessment."
			},
			"block": {
				"badgeText_one": "{{count}} Application Blocked",
				"badgeText_other": "{{count}} Applications Blocked",
				"title": "Add Specific Applications to Block",
				"description": "Select one or more applications from the list below that test-takers are <b>not permitted to use</b> during the assessment.",
				"descriptionLink": "Select one or more applications from the list below that test-takers are <b>not permitted to use</b> during the assessment. If an application is not listed, <a>Add New Application</a>",
				"note": "All applications not in the blocked applications list will be allowed during the assessment."
			},
			"filter": {
				"all": "All Applications",
				"allowed": "Allowed Applications",
				"blocked": "Blocked Applications"
			},
			"addCustomApplication": "Add Custom Application"
		},
		"disableExtensionList": {
			"title": "Allow Browser Extensions",
			"description": "Select one or more browser extensions that test-takers are <b>permitted to use</b> during the assessment.",
			"descriptionLink": "Select one or more browser extensions that test-takers are <b>permitted to use</b> during the assessment. If an extension is not listed, <a>Add New Extension</a>.",
			"addExtension": "Add Extension",
			"placeholder": "Search by application name",
			"badgeText_one": "{{count}} Extension Allowed",
			"badgeText_other": "{{count}} Extensions Allowed",
			"filter": {
				"all": "All Extensions",
				"selected": "Allowed Extensions",
				"notSelected": "Not Allowed Extensions"
			},
			"filterLabel": "Filter extensions",
			"selectAriaLabel": "Filter extensions",
			"addCustomExtension": "Add Custom Extension"
		},
		"flaggedKeywordsList": {
			"title": "Add Flagged Keywords",
			"settingTitle": "Configure Flagged Keywords",
			"description": "Add words or phrases that will be flagged when said during assessments.",
			"placeholder": "Enter a keyword",
			"add": "Add",
			"edit": "Edit",
			"badgeText": {
				"setting": "{{count}} Selected",
				"quiz": "{{count}} Added"
			},
			"noResults": {
				"title": "Start Adding Keywords",
				"subtitle": "Add a word like “Hello” or a short phrase like “What’s the answer” to create your keyword list."
			},
			"disabledBadge": "Set by Institution",
			"disabledRow": "This keyword has been set by your institution",
			"selectedBadge": "Selected",
			"textFieldLabel": "Add keyword"
		},
		"geofenceList": {
			"addGeofence": "Add New Location",
			"disabledTooltip": "Max {{number}} allowed.",
			"title": "Select Geofence",
			"description": "Select a location from the existing list, or create a new location",
			"descriptionSettings": "Add up to five geofence areas. You can then select these geofences when applying location limits for an assessment.",
			"tableLocationHeader": "Location Name",
			"noLocations": "No geofence locations have been added.",
			"edit": "Edit",
			"remove": "Remove",
			"view": "View",
			"radiusKm": "{{radius}} km",
			"radiusMiles": "{{radius}} mi",
			"radiusMeter": "{{radius}} m",
			"radiusFeet": "{{radius}} ft",
			"actionAriaLabel": "More Actions"
		},
		"disclaimerModal": {
			"title": "Verity Not Found in Canvas Theme",
			"cancel": "Cancel",
			"continue": "Continue",
			"bodyLink": "Your Canvas administrator has not added Verity to your Canvas theme. <a>Learn More</a>.",
			"bodyText": "Having Verity added to your Canvas theme can help guide test-takers in accessing their assessments. Without it, you will need to give test-takers details on how to authenticate themselves and the password to access their assessments.",
			"checkboxText": "I understand",
			"disclaimerAriaLabel": "Learn more about adding Verity to your Canvas theme. Opens in a new tab."
		},
		"configurationSummaryListTSX": {
			"systemClipboard": "System Clipboard Disabled",
			"calculator": "{{type}} Calculator",
			"additionalSettings": "Additional Settings",
			"additionalSettingsFor": "{{label}} - Additional Settings",
			"bypassMode": "Allow test-takers to continue their assessment if this restriction is violated",
			"geofenceTitle_one": "Selected Geofence",
			"geofenceTitle_other": "Selected Geofences",
			"listLinkAriaLabel": "Open {{url}} in a new tab.",
			"blockExtensions_one": "{{count}} Browser Extension Allowed",
			"blockExtensions_other": "{{count}} Browser Extensions Allowed",
			"allExtensionsBlocked": "All Browser Extensions Blocked",
			"blockList_one": "Block {{count}} Application",
			"blockList_other": "Block {{count}} Applications",
			"allowList_one": "Allow {{count}} Application",
			"allowList_other": "Allow {{count}} Applications",
			"allApplicationsBlocked": "All Applications Blocked",
			"tabWhiteList_one": "{{count}} Permitted Website",
			"tabWhiteList_other": "{{count}} Permitted Websites",
			"input": "Input Settings",
			"inputAriaLabel": "View Input Settings",
			"tabSettings": "Tab Settings",
			"tabSettingsAriaLabel": "View Tab Settings",
			"oneScreenSettings": "Screen Settings",
			"oneScreenAriaLabel": "View Screen Settings",
			"handoffSettings": "Handoff Settings",
			"handoffAriaLabel": "View Handoff Settings",
			"locationSettings": "Location Settings",
			"locationAriaLabel": "View Location Settings",
			"extensionSettings": "Browser Extension Settings",
			"extensionAriaLabel": "View Browser Extension Settings",
			"applicationSettings": "Desktop Application Settings",
			"applicationAriaLabel": "View Desktop Application Settings",
			"video": "Video",
			"audio": "Audio",
			"compact": {
				"record": "Recording",
				"recordingSummary": "{{items}} will be recorded.",
				"verification": "Identity Verification",
				"verificationSummary": "{{items}} will be verified.",
				"additionalRestrictions": "Additional Restrictions",
				"showTools": "Resources",
				"resourceSummary": "Test-takers will have access to a {{items}}."
			}
		},
		"confirmationBlockTSX": {
			"thirdPartyPlatform": "Third-Party Platform",
			"defaultPlatform": "Others",
			"assessmentName": "Assessment Name",
			"assessmentUrl": "Assessment Url",
			"passwordProtection": "Password Protection",
			"yes": "Yes",
			"no": "No",
			"method": "Method",
			"manageAccommodations": "Manage Accommodations",
			"accommodationHint": "Customize or waive proctoring restrictions for individual test-takers.",
			"noRestrictions": "Proctoring configurations have not been applied.",
			"editButtonAriaLabel": "Go back to {{page}} step to edit selection",
			"editButtonTooltip": "Edit {{page}}",
			"editButtonLabel": "Edit",
			"viewMore": "View More",
			"viewLess": "View Less",
			"platform": "Platform",
			"platformRequired": "{{platform}} Required",
			"additionalPlatforms": "Supported in",
			"supportedBrowsers": "View Supported Browsers",
			"supportedPlatforms": "View Supported Platforms",
			"profileDetails": "Profile Name",
			"noAccommodations": "No test-takers have been accommodated",
			"numAccommodated_one": "<b>{{count}}</b> test-taker has been accommodated",
			"numAccommodated_other": "<b>{{count}}</b> test-takers have been accommodated",
			"accommodation": "Accommodation",
			"modifiedProctoring": "Modified Proctoring",
			"notProctored": "Not Proctored",
			"accommodationDetails": "Accommodation Details",
			"testTaker": "Test-taker",
			"accommodationNotes": "Accommodation Notes",
			"noNotes": "No Accommodation Notes",
			"incompleteLabel": "Complete this setup to continue",
			"liveSession": "Live Sessions",
			"numSession_one": "{{count}} session",
			"numSession_other": "{{count}} sessions",
			"assessmentType": "Assessment Type",
			"type": "Type",
			"assignment": "Assignment",
			"quiz": "Quiz",
			"questions": "Questions",
			"totalQuestions": "Total Questions",
			"totalPoints": "Total Points",
			"assessmentDetails": "Assessment Details",
			"manageAssessmentDetails": "View Assessment Details",
			"assessmentTitle": "Title",
			"assessmentDescription": "Description",
			"course": "Selected Course",
			"syncWithGradebook": "Sync with Gradebook",
			"assessmentDueDate": "Due Date",
			"lateSubmission": "Accept Submission by:",
			"assessmentDuration": "Assessment Duration",
			"unlimited": "Unlimited",
			"numAttempts": "Number of Attempts Allowed",
			"allowedFileTypes": "Allowed File Types",
			"allFileTypes": "All file types allowed",
			"instructions": "Instructions",
			"module": "Selected Module",
			"assignmentMaxPoints": "Points",
			"gradeBook": "Grade Book Scoring",
			"showScoreOnSubmission": "Show Score After Submission",
			"emailInstructions": "Email Instructions",
			"testTakers": "Test-takers",
			"manageTestTakers": "View Test-Takers"
		},
		"proctoringOptionsTextTSX": {
			"bypassModeText": "Allow test-takers to continue their assessment if this restriction is violated",
			"badge": {
				"extension": {
					"badge": "Extension Only",
					"tooltip": "Only available for assessments taken through Browser Extension."
				},
				"lockdown": {
					"badge": "Desktop Only",
					"tooltip": "Only available for assessments taken through Desktop Lockdown App."
				},
				"mobile": {
					"badge": "Mobile Only",
					"tooltip": "Only available for assessments taken through Mobile Lockdown App."
				},
				"chromeOs": {
					"badge": "Chromebook Only",
					"tooltip": "Only available for assessments taken through Chromebook Lockdown App."
				},
				"browser": {
					"badge": "Web Browser Only",
					"tooltip": "Only available for assessments proctored directly in the browser."
				}
			},
			"method": {
				"automated": "Automated Proctoring",
				"isLiveProctored": "Live Assessment",
				"isLivePopIn": "Live Check-In",
				"enablePostReview": "Live Check-In with Post-Assessment Review"
			},
			"platform": {
				"extensionDescription": "Access standard proctoring features requiring the Verity Browser Extension.",
				"lockdownDescription": "Access advanced proctoring features requiring the Lockdown App for Windows and Mac.",
				"mobileDescription": "Access core proctoring features using the Verity Mobile App for iOS and Android devices.",
				"extension": "Browser Extension",
				"lockdown": "Desktop Lockdown App",
				"mobile": "Mobile Lockdown App",
				"chromeOs": "Chromebook Lockdown App",
				"and2": "{{platform1}} and {{platform2}}",
				"andMany": "{{platforms}}, and {{lastPlatform}}",
				"none": "No Platforms",
				"compact": {
					"extension": "Browser Extension",
					"lockdown": "Desktop Lockdown App",
					"mobile": "Mobile",
					"chromeOs": "Chromebook",
					"browser": "Web Browser"
				},
				"browser": "Web Browser",
				"browserDescription": "Access essential proctoring features with no downloads or extensions required."
			},
			"record": {
				"videoRecordingMode": {
					"header": "Record Video",
					"description": "Test-taker's webcam will record their testing environments",
					"setting": "Test-taker's webcam will record their testing environments",
					"compactHeader": "Video Monitored"
				},
				"audioRecordingMode": {
					"header": "Record Audio",
					"description": "Use the test-taker's microphone to record audio",
					"setting": "Use the test-taker's microphone to record audio",
					"compactHeader": "Audio Monitored"
				},
				"quietEnvironment": {
					"header": "Quiet Environment",
					"description": "Notify test-taker if their testing environment is too loud and flag the event.",
					"setting": "Notify test-taker if their testing environment is too loud and flag the event.",
					"compactHeader": "Quiet Environment Required"
				},
				"recordScreen": {
					"header": "Record Screen",
					"description": "Test-taker's screen will be recorded",
					"setting": "Test-taker's screen will be recorded",
					"compactHeader": "Screen"
				},
				"scanRoom": {
					"header": "Room Scan",
					"description": "Require a 360° scan of the testing environment",
					"setting": "Require a 360° scan of the testing environment",
					"compactHeader": "Room Scan"
				},
				"faceTrackingMode": {
					"header": "Exactly One Test-taker",
					"description": "Detect if more than one person is visible on camera",
					"setting": "Detect if more than one person is visible on camera",
					"compactHeader": "Multiple People Monitored"
				},
				"objectDetectionMode": {
					"header": "Suspicious Objects",
					"description": "Test-taker's webcam monitor for suspicious objects",
					"setting": "Test-taker's webcam monitor for suspicious objects",
					"compactHeader": "Suspicious Objects Monitored"
				},
				"secondaryVideoRecordingMode": {
					"header": "Secondary Camera",
					"compactHeader": "Secondary Camera Required",
					"setting": "Test-takers are required to have an additional camera or a mobile device."
				},
				"audio": {
					"audioTranscription": {
						"header": "Audio Transcription",
						"description": "<b>Create a transcript</b> of the audio",
						"setting": "Transcribe recorded audio from the test-taker's microphone.",
						"compactHeader": "Audio Transcript Enabled"
					},
					"flaggedKeywords": {
						"header": "Flagged Keywords",
						"description": "Enable automatic <b>flagging of specified keywords</b>",
						"setting": "Automatically flag specific spoken keywords during the assessment.",
						"compactHeader": "Flagged Keywords Enabled"
					}
				}
			},
			"verification": {
				"idVerification": {
					"header": "ID Verification",
					"description": "Test-taker must capture and upload their ID and face before the assessment begins.",
					"setting": "Test-takers must show their IDs and face to their webcams for verification.",
					"compactHeader": "ID card"
				},
				"uploadSignature": {
					"header": "Signature Check",
					"description": "Test-takers must provide their signature before the assessment to verify their identity and acknowledge the proctoring restrictions.",
					"setting": "Test-takers must provide their signature before the assessment to verify their identity and acknowledge the proctoring restrictions.",
					"compactHeader": "Signature"
				},
				"idVerificationEnableAi": {
					"header": "AI ID Verification",
					"compactHeader": "AI ID card",
					"setting": "Automatically detect and verify the test-taker's face against their uploaded ID."
				}
			},
			"disableFeatures": {
				"disableClipboardMode": {
					"header": "Disable Clipboard",
					"description": "Test-taker will not be able to copy or paste items.",
					"setting": "Clipboard functionality is disabled.",
					"compactHeader": "Clipboard Disabled"
				},
				"disableDownloadFiles": {
					"header": "Disable File Download",
					"description": "Test-taker will not be able to download images and web pages.",
					"setting": "Test-takers will be unable to download images and web pages.",
					"compactHeader": "File Download Disabled"
				},
				"disableSpellcheck": {
					"header": "Disable Spell-Check",
					"description": "Test-taker will not be able to use the browser’s spell check.",
					"setting": "Browsers' spell-check functionality will be disabled.",
					"compactHeader": "Spell Check Disabled"
				},
				"disablePrinting": {
					"header": "Disable Printing",
					"description": "Test-taker will not be able to print.",
					"setting": "Print functionality will be disabled.",
					"compactHeader": "Printing Disabled"
				},
				"disableRightClick": {
					"header": "Disable Right Click",
					"description": "Test-taker will not be able to use the right click on their mouse or trackpad.",
					"setting": "Right-click functionality will be disabled.",
					"compactHeader": "Right Click Disabled"
				},
				"extensionBlockMode": {
					"header": "Disable Browser Extensions",
					"description": "Test-takers will not be able to enable any browser extensions except the ones that are allowed.",
					"setting": "Test-takers will not be able to enable any browser extensions except the ones that are allowed.",
					"compactHeader": "Browser Extensions Disabled"
				},
				"enableGuidedAccessMode": {
					"header": "Block Mobile Apps",
					"description": "Taking a proctored assessment in the Verity Mobile Lockdown App will block other apps from opening.",
					"setting": "Other apps are blocked from opening during a proctored assessment on mobile.",
					"compactHeader": "Mobile Apps Disabled"
				},
				"restrictHandoffMode": {
					"header": "Disable Handoff",
					"description": "Test-takers using Apple devices must turn off Handoff before the assessment.",
					"setting": "Test-takers using Apple devices must turn off Handoff before the assessment. <a>Learn more</a>.",
					"compactHeader": "Handoff Disabled"
				},
				"disableVirtualCamera": {
					"header": "Disable Virtual Camera",
					"description": "Test-taker will not be able to use any virtual cameras.",
					"setting": "Test-taker will not be able to use any virtual cameras.",
					"compactHeader": "Virtual Camera Disabled"
				},
				"blockVirtualMachines": {
					"header": "Block Virtual Machines",
					"description": "Test-taker will not be able to open their assessment inside a virtual machine.",
					"setting": "Assessments will be prohibited from being taken inside virtual machines.",
					"compactHeader": "Virtual Machines Disabled"
				},
				"applicationBlockMode": {
					"header": "Manage Desktop Applications",
					"description": "Manage what applications test-takers can access during the assessment.",
					"setting": "A created list of applications test-takers will not be able to access.",
					"compactHeader": "Desktop Applications Disabled"
				},
				"recordApplicationsActivity": {
					"header": "Monitor Desktop Applications",
					"description": "Any time a desktop application is opened or closed, it will be recorded.",
					"setting": "Any time a desktop application is opened or closed, it will be recorded.",
					"compactHeader": "Desktop Applications Monitored"
				},
				"logRunningApplications": {
					"header": "View Running Applications",
					"description": "Enable instructors and proctors to review applications running on the test-taker’s device before the assessment begins.",
					"setting": "Enable instructors and proctors to review applications running on the test-taker’s device before the assessment begins.",
					"compactHeader": "Running Applications Reviewed"
				}
			},
			"otherActivities": {
				"excludedWebTrafficRecordingUrls": {
					"header": "Exclude Record Web Traffic Websites",
					"description": "Websites excluded from recording web traffic."
				},
				"disableNewTab": {
					"header": "Disable New Tabs",
					"description": "Test-taker will not be able to open any new tabs except for assessment resources.",
					"setting": "Test-taker will not be able to open any new tabs except for assessment resources.",
					"compactHeader": "New Tabs Disabled"
				},
				"closeOpenTabs": {
					"header": "Close Open Tabs",
					"description": "Test-taker must close all tabs before the assessment begins.",
					"setting": "Test-takers will be required to close all open tabs before starting their assessment.",
					"compactHeader": "Existing Tabs Disabled"
				},
				"tabWhiteList": {
					"header": "Assessment Resources",
					"description": "Add a list of permitted websites that test-takers can use as resources during the assessment.",
					"setting": "A list of permitted websites that test-takers can use as resources during the assessment.",
					"compactHeader": "Permitted Websites"
				},
				"recordWebTraffic": {
					"header": "Record Web Traffic",
					"description": "Websites accessed from a browser with the Verity extension installed will be recorded.",
					"setting": "Websites will be recorded when accessed from a browser with the Verity extension installed.",
					"compactHeader": "Web Traffic Monitored"
				},
				"detectSidePanel": {
					"header": "Monitor Side Panel Activities",
					"description": "Activity in the browser's side panel, including AI tools and extensions, will be monitored.",
					"setting": "Activity in the browser's side panel, including AI tools and extensions, will be monitored.",
					"compactHeader": "Side Panel Activities Monitored"
				},
				"recordInput": {
					"header": "Record Keyboard",
					"description": "Test-taker’s keyboard inputs will be recorded during the assessment.",
					"setting": "Test-taker's keystrokes will be recorded.",
					"compactHeader": "Keyboard Inputs Monitored"
				},
				"recordClipboard": {
					"header": "Record Clipboard",
					"description": "Test-taker’s clipboard will be recorded during the assessment.",
					"setting": "Items copied to test-taker's clipboards will be recorded.",
					"compactHeader": "Clipboard Monitored"
				},
				"oneScreenEnforcementMode": {
					"header": "Only One Screen",
					"description": "Test-taker must unplug additional displays to ensure only one screen is in use.",
					"setting": "Test-takers will only be able to use one monitor.",
					"compactHeader": "Multiple Screens Disabled"
				},
				"hideOtherWindows": {
					"header": "Hide Other Applications",
					"description": "Test-taker will only be able to view the Verity Lockdown App during the assessment.",
					"setting": "Test-takers will only be able to view the Verity Lockdown App."
				},
				"uploadScratchNotes": {
					"header": "Work Attachments",
					"description": "Test-takers will be asked to capture and upload work attachments, such as handwritten notes.",
					"setting": "Test-takers will be asked to capture and upload work attachments, such as handwritten notes.",
					"compactHeader": "Work Attachments Enabled"
				},
				"restrictDevices": {
					"header": "Restrict Mobile Device",
					"description": "Test-takers will be asked to restrict their mobile device using the Verity Mobile Lockdown App.",
					"setting": "Test-takers will be asked to restrict their mobile device using the Verity Mobile Lockdown App. <a>Learn more</a>.",
					"descriptionAriaLabel": "Learn more about restricting mobile devices using Verity Mobile Lockdown App (opens in a new tab).",
					"compactHeader": "Mobile Device Disabled"
				},
				"enableGeofence": {
					"header": "Restrict Assessment Location",
					"description": "Test-takers must be within the configured location before starting and throughout the assessment.",
					"setting": "Test-takers must be within the configured location before starting and throughout the assessment.",
					"compactHeader": "Assessment Location Monitored"
				},
				"enableIpAddressRestriction": {
					"header": "Restrict by IP Address",
					"description": "Require test-takers to connect from an approved IP address range to access the assessment.",
					"setting": "Require test-takers to connect from an approved IP address range to access the assessment.",
					"compactHeader": "IP Address Restricted"
				},
				"logInstalledExtensions": {
					"header": "View Installed Browser Extensions",
					"description": "Allow instructors and proctors to review installed browser extensions before the assessment.",
					"setting": "Allow instructors and proctors to review installed browser extensions before the assessment.",
					"compactHeader": "Installed Browser Extensions Reviewed"
				},
				"enableManualEndProctoring": {
					"header": "Manual End Proctoring",
					"description": "Test-takers can manually end their proctoring session when using the Desktop Lockdown App.",
					"setting": "Test-takers can manually end their proctoring session when using the Desktop Lockdown App.",
					"compactHeader": "Manual End Proctoring Enabled"
				}
			},
			"showTools": {
				"enableCalculator": {
					"header": "Calculator",
					"description": "Test-taker will have access to a calculator during the assessment.",
					"setting": "A calculator will be available to test-takers.",
					"compactHeader": "Calculator"
				},
				"enableWhiteboard": {
					"header": "Whiteboard",
					"description": "Test-taker will have access to a whiteboard during the assessment.",
					"setting": "A whiteboard will be available for test-takers to write on.",
					"compactHeader": "Whiteboard"
				},
				"enableCodeEditor": {
					"header": "Code Editor",
					"description": "Test-taker will have access to a code editor during the assessment.",
					"setting": "A code editor will be available for test-takers to write on.",
					"compactHeader": "Code Editor"
				},
				"enableReferenceMaterial": {
					"header": "Reference Material",
					"description": "Allow reference material and choose who provides it.",
					"setting": "Allow reference material and choose who provides it.",
					"compactHeader": "Reference Material"
				},
				"referenceMaterialMode": {
					"header": "Reference Material",
					"description": "Test-taker will have access to reference material during the assessment.",
					"setting": "Test-taker will have access to reference material during the assessment.",
					"compactHeader": "Reference Material"
				}
			},
			"groupedOption": {
				"tabControl": {
					"header": "Tab Restrictions",
					"description": "Manage how test-takers interact with browser tabs during the assessment."
				}
			},
			"stepName": {
				"record": "Recording",
				"verification": "Verification",
				"otherActivities": "Restrictions",
				"showTools": "Resources",
				"thirdParty": "Third-Party",
				"platform": "Platform",
				"profile": "Profile",
				"configuration": "Configuration",
				"method": "Method",
				"liveSessions": "Live Sessions",
				"accommodations": "Accommodation",
				"confirmation": "Review",
				"assessmentDetails": "Assessment Details",
				"inviteTestTakers": "Invite Test-Takers",
				"assessmentType": "Assessment Type",
				"instructions": "Add Instructions",
				"questions": "Questions",
				"editQuiz": "Verity Configuration",
				"review": "Review"
			}
		},
		"profileStep": {
			"unknownProfile": "Unknown Profile",
			"description": "Select a preset proctoring restriction profile or create your own custom configuration.",
			"viewProfileTitle": "Proctoring Profile: {{profile}}",
			"viewProfileDesc": "View the details and a list of proctoring configurations of this profile.",
			"standard": {
				"name": "Standard Proctoring Profile",
				"desc": "Provides video, audio, screen, and room scan, along with ID verification and proctoring restrictions for browser tabs.",
				"recording": "Video, audio, room scan, and ID verification",
				"restrictions": "Prevent opening new or additional browser tabs"
			},
			"advanced": {
				"name": "Advanced Proctoring Profile",
				"desc": "Applies the highest level of security using the Lockdown App. All proctoring and access restrictions are enforced.",
				"recording": "Video, audio, room scan, and ID verification",
				"restrictions": "Block new and additional browser tabs|Disable clipboard and handoff functionality|Block virtual machines and background applications|Restrict usage to a single screen"
			},
			"essential": {
				"name": "Essential Proctoring Profile",
				"desc": "A minimal proctoring configuration that only prioritizes ID verification and recording.",
				"recording": "Video, audio, screen, and ID verification",
				"restrictions": "Restrict usage to a single screen"
			},
			"institution": {
				"name": "Institution",
				"desc": "Provides predefined proctoring restriction by your institution."
			},
			"course": {
				"name": "Course",
				"desc": "Provides predefined proctoring restrictions specific to this course."
			},
			"user": {
				"name": "Individual",
				"desc": "Provides a predefined proctoring restrictions created by you."
			},
			"subAccount": {
				"name": "Sub-Account",
				"desc": "Provides predefined proctoring restrictions for this LMS sub-account."
			},
			"custom": {
				"title": "Create Your Own Configuration",
				"description": "Select how your assessment will be monitored and choose the access restrictions to apply.",
				"badge": "Customize"
			},
			"seeMoreProfiles": "See More Profiles",
			"profileType": "Profile Type",
			"preset": "Preset",
			"platform": "Platform",
			"recording": "Recording",
			"restrictions": "Restrictions",
			"recommended": "Recommended",
			"configurationTriggerAriaLabel": "View Configuration Details",
			"configuration": "Configuration Details",
			"institutionRequiredProfiles": "Your institution requires you to choose from a pre-designated set of profiles for your assessment.",
			"placeholder": "Search by profile name",
			"view": "View",
			"delete": "Delete",
			"actionsButtonAriaLabel": "More actions",
			"back": "Back to Profiles"
		},
		"saveProfileModalTSX": {
			"title": "Save Proctoring Setup as Profile",
			"description": "You can save your proctoring settings as a profile to apply them in future assessments.",
			"warning": "When saving as a profile, <b>Third-Party Integration, Proctoring Method, Accommodated Test-Takers, and Uploaded Reference Material</b> will not be included.",
			"warningNoThirdParty": "When saving as a profile, <b>Proctoring Method, Accommodated Test-Takers, and Uploaded Reference Material</b> will not be included.",
			"details": "Details",
			"detailsDescription": "Enter the name of your profile.",
			"profileName": "Profile Name:",
			"profileNamePlaceholder": "Enter profile name",
			"saveLocation": "Save Location",
			"saveLocationDescription": "Choose where you would like to save the rubric.",
			"instituteDescription": "<b>Institution:</b> The proctoring profile will be available to everyone in the institution.",
			"subAccountDescription": "<b>{{type}}:</b> The proctoring profile will be available for selected {{typePlural}}.",
			"courseDescription": "<b>Course:</b> The proctoring profile will be available to everyone in the course.",
			"selectSubAccounts": "Select one or more {{type}} for this profile.",
			"searchSubAccounts": "Search {{type}}",
			"noSubAccounts": "No {{type}} found",
			"userDescription": "<b>Individual:</b> The proctoring profile will only be available to you.",
			"enterProfileName": "Enter profile name",
			"cancel": "Cancel",
			"save": "Save",
			"success": "The proctoring profile has been successfully saved.",
			"error": "The proctoring profile could not be saved.",
			"updateSuccess": "The proctoring profile has been updated",
			"updateModal": {
				"title": "Save Proctoring Setup as Profile",
				"titleShort": "Save as Profile",
				"no": "Cancel",
				"createNewProfile": "Create New Profile",
				"updateProfile": "Update Existing Profile",
				"description": "Would you like to update the existing profile ({{profileName}}) with the current changes? Updating this profile will permanently replace the existing configuration and cannot be reversed. Alternatively, you may create a new proctoring profile to preserve the current setup."
			}
		},
		"noConfigurations": {
			"title": "No Configurations Enabled",
			"cancel": "Cancel",
			"yes": "Yes",
			"description": "You have not enabled any configurations to monitor or restrict the test-taker. Are you sure you want to continue?"
		},
		"unsupportedModalTSX": {
			"title": "Some Features Are Not Supported",
			"enableAnyway": "Enable Anyway",
			"cancel": "Cancel",
			"continue": "Disable and Continue",
			"defaultPlatform": "Other",
			"extensionDesc": "The {{platform}} does not support the following restrictions. Continuing will deactivate these features. Do you want to proceed?",
			"otherPlatform": "The {{platform}} app does not support the following restrictions. Continuing will deactivate these features. Do you want to proceed?",
			"passwordConflict": "Setting an assessment password will not allow right-click to be disabled. This allows test-takers to automatically inject the password for their assessments. Do you want to disable the feature and continue?",
			"defaultDescription": "The selected proctoring platform configuration does not support the following restrictions. Continuing will deactivate these features. Do you want to proceed?",
			"multiPlatform": "The following proctoring platforms do not support the following restrictions."
		}
	},
	"installLockdown": {
		"launchingLockdown": "Launching Verity Lockdown App",
		"stepOne": {
			"title": "Do Not Have the App?",
			"description": "Download and install the app, then launch once done.",
			"downloadApp": "Download Lockdown App"
		},
		"stepTwo": {
			"title": "Already Installed the App?",
			"description": "Simply launch the app to start your test.",
			"compatibilityCheckDescription": "Simply launch the app to start your compatibility check.",
			"launchApp": "Launch Lockdown App"
		},
		"or": "OR",
		"infoText": "After launching, log in to your LMS and open your proctored assessment in the app.",
		"lmsAssessmentLink": "LMS Assessment Link",
		"compatibilityCheckLink": "Assessment Compatibility Check Link",
		"copyLinkText": "Copy the LMS Link and input it directly into the Lockdown App:",
		"copyLinkTextCompatibility": "Copy the compatibility check link and input it directly into the Lockdown App:",
		"contactSupport": "Still having trouble? Contact YuJa Support",
		"copy": "Copy",
		"copied": "Copied!",
		"windowsOrMacOnlyMsg": "The Lockdown App is only available on Windows and Mac devices.",
		"launching": "Launching...",
		"collapse": "Collapse section",
		"expand": "Expand section"
	},
	"installMobile": {
		"launchTheVerityMobileApp": "Launch the Verity Mobile App",
		"launchVerity": "Launch Verity",
		"hasNotLaunched": "If the Verity Mobile App has not launched, follow the steps below:",
		"downloadMobileApp": "Download the App Now",
		"DownloadOnThe": "Download on the",
		"appStore": "App Store",
		"getItOn": "GET IT ON",
		"googlePlay": "Google Play",
		"launchTheAppToRedirect": "Launch the app to be redirected to the LMS Login Page.",
		"navigateToAssessment": "Navigate to the proctored assessment.",
		"contactSupport": "Still having trouble? Contact YuJa Support"
	},
	"interceptStrategy": {
		"badge": "Proctored",
		"checkboxError": {
			"thirdPartyTitle": "YuJa Verity Test Proctoring Platform",
			"thirdPartyTooltip": "Create a proctored environment to safeguard the integrity of your assessment through custom settings.",
			"error": {
				"noExtension": "To set up proctoring for your assessment, install the <a>Verity Browser Extension</a>, then go to YuJa Verity from your course to continue.",
				"auth": "To set up proctoring for your assessment, go to YuJa Verity from your course to authenticate and continue."
			},
			"openNewLinkAriaLabel": "Install the Verity Browser Extension. Opens in a new tab."
		}
	},
	"coreComponents": {
		"table": {
			"sortTooltip": "Sort {{columnName}}"
		},
		"stepper": {
			"ariaLabel": "{{count}}-step progress bar",
			"stepAriaLabel": "Step {{index}} of {{count}}, {{status}}, {{label}}",
			"current": "current",
			"completed": "completed",
			"incomplete": "not completed",
			"complete": "complete"
		},
		"searchField": {
			"clearAriaLabel": "Clear search input",
			"searchButton": "Search",
			"emptySearchSrText_one": "Showing {{count}} result",
			"emptySearchSrText_other": "Showing {{count}} results",
			"searchSrText_one": "Showing {{count}} result for {{searchQuery}}",
			"searchSrText_other": "Showing {{count}} results for {{searchQuery}}"
		},
		"copyButton": {
			"copy": "Copy to clipboard",
			"copied": "Copied!"
		},
		"filter": {
			"title": "Filter",
			"clear": "Clear All",
			"cancel": "Cancel",
			"apply": "Apply",
			"ariaLabel": "Filter",
			"ariaLabelSelected": "Filter ({{count}} selected)",
			"tooltipText": "Filter"
		},
		"coreError": {
			"warning": "Warning"
		},
		"coreSwitch": {
			"enabled": "Enabled",
			"disabled": "Disabled"
		},
		"breadcrumb": {
			"breadcrumb": "breadcrumb"
		},
		"divider": {
			"OR": "OR"
		},
		"coreList": {
			"groupButtonAriaLabelExpand": "Expand {{group}}",
			"groupButtonAriaLabelCollapse": "Collapse {{group}}",
			"selectAllAriaLabel": "Select all in {{group}}",
			"deselectAllAriaLabel": "Remove all selection in {{group}}",
			"selectOneAriaLabel": "Select {{label}}",
			"deselectOneAriaLabel": "Remove selection for {{label}}",
			"selectOneGeneric": "Select",
			"deselectOneGeneric": "Remove selection"
		},
		"modal": {
			"back": "Back",
			"close": "Close",
			"closeButtonAriaLabel": "Close Dialog"
		},
		"note": {
			"note": "Note:"
		},
		"confirmationModal": {
			"cancel": "Cancel",
			"confirm": "Confirm",
			"iUnderstandInstructions": "Type “<b>I understand</b>” to continue.",
			"iUnderstandPlaceholder": "Enter I understand",
			"iUnderstand": "I understand"
		},
		"datePicker": {
			"cancel": "Cancel",
			"confirm": "Confirm",
			"clear": "Clear"
		},
		"infoIndicator": {
			"moreInfoAriaLabel": "More Info"
		},
		"radioCard": {
			"checkedAriaLabel": "Selected"
		},
		"logo": {
			"verityLogoAlt": "YuJa Verity"
		},
		"fileTypeSelector": {
			"removeAriaLabel": "Remove {{label}}"
		},
		"tabs": {
			"nextButtonAriaLabel": "Next tab",
			"previousButtonAriaLabel": "Previous tab"
		},
		"fileCard": {
			"download": "Download",
			"remove": "Remove",
			"openInNewTab": "Open in new tab",
			"completed": "Completed"
		},
		"pdfViewer": {
			"pageNumberAriaLabel": "Page number",
			"zoomInAriaLabel": "Zoom in",
			"zoomOutAriaLabel": "Zoom out",
			"previousPageLabel": "Previous page",
			"nextPageLabel": "Next page",
			"openInNewTabAriaLabel": "Open in new tab",
			"loadErrorMessage": "Failed to load PDF file",
			"enterPasswordPrompt": "This PDF is password protected. Enter the password to view it.",
			"incorrectPasswordPrompt": "Invalid password. Please try again.",
			"passwordCanceledError": "A password is required to open this PDF file.",
			"retryLabel": "Try again",
			"passwordInputAriaLabel": "PDF password",
			"submitLabel": "Submit",
			"cancelLabel": "Cancel",
			"passwordModalTitle": "Password Required"
		},
		"banner": {
			"close": "Close"
		},
		"timer": {
			"timer": "{{hour}}:{{min}}:{{sec}}"
		},
		"filePreview": {
			"alt": "Preview of {{fileName}}"
		},
		"fileLayoutSlider": {
			"ariaLabel": "File layout slider",
			"decreaseButtonAriaLabel": "Decrease grid size",
			"increaseButtonAriaLabel": "Increase grid size"
		},
		"selectSearch": {
			"placeholder": "Search..."
		},
		"backButton": {
			"back": "Back",
			"cancel": "Cancel"
		},
		"titleCard": {
			"backButtonAriaLabel": "Back to {{pageName}}"
		},
		"profileButton": {
			"myAccount": "My Account"
		},
		"userMenu": {
			"institutions": "Institutions",
			"install": "Install",
			"accountManagers": "Account Managers",
			"applications": "Applications",
			"liveProctoring": "Live Proctoring",
			"feedback": "Feedback",
			"events": "Events",
			"disabledInstitutions": "Disabled Institutions",
			"auditLogs": "Audit Logs",
			"signOut": "Sign Out",
			"support": "Support",
			"settings": "Settings",
			"setup": "User Setup",
			"quickSetup": "Quick Setup Guide",
			"yujaAdmin": "YuJa Admin",
			"customerAdmin": "Admin",
			"accountManager": "Account Manager"
		},
		"menuButton": {
			"ariaLabel": "Actions"
		},
		"lmsIcon": {
			"ariaLabel": "{{lms}} Icon"
		},
		"passFailRow": {
			"pass": "Pass",
			"fail": "Fail"
		}
	},
	"beforeQuiz": {
		"title": "Verity Proctoring Pre-Assessment Check",
		"title2Lines": "Verity Proctoring\nPre-Assessment Check",
		"titleCompatibility": "Assessment Compatibility Check",
		"closeAriaLabel": "Close",
		"buttons": {
			"next": "Next",
			"back": "Back",
			"startCheck": "Start Assessment Check",
			"upload": "Uploading...",
			"startAssessment": "Start Assessment",
			"startingAssessment": "Starting Assessment...",
			"continueAnyway": "Continue Anyway",
			"viewReport": "View Report",
			"screenShare": "Please select your entire screen to share.",
			"startRoomScan": "Complete your room scan to continue."
		},
		"tip": "Tip",
		"timer": "<b>{{hour}}</b>h <b>{{min}}</b>m <b>{{sec}}</b>s",
		"timerLabel": "Live Proctoring Ends In",
		"scrollDown": "Scroll Down",
		"substepCompleted": "Completed",
		"substepFailed": "Failed",
		"stepper": {
			"payment": "Payment",
			"systemCheck": "System Check",
			"assessmentSetup": "Assessment Setup",
			"deviceSetup": "Device Setup",
			"roomScan": "Room Scan",
			"verifyIdentity": "ID Check",
			"mobileConnect": "Secure Access",
			"signatureOnly": "Signature Verification",
			"referenceMaterial": "Reference Material",
			"review": "Review and Confirm"
		},
		"supportChat": {
			"guidedSupport": "Guided Support",
			"openGuidedSupport": "Open Guided Support",
			"fetchingResponse": "Fetching response from support...",
			"askAboutIssue": "Ask about an issue",
			"basicGreeting": "Hello! I'm here to help you with your Verity proctoring setup. What issue are you experiencing?",
			"sendMessage": "Send Message",
			"closeSupportChat": "Close support chat",
			"commandButtons": {
				"disableBrowserExtension": "Disabling Browser Extension",
				"enableIncognitoMode": "Enabling Incognito Mode",
				"disableHandoff": "Disabling Handoff",
				"closeOpenApplications": "Manually Closing an Application",
				"helpCenter": "Verity Help Center",
				"getHelp": "Get Help",
				"basicHelpMessage": "Looks like you’re having an issue. Click the button below to get help with your issue and resolve it to complete your pre-assessment check."
			}
		},
		"welcome": {
			"title": "Let’s Get You Ready",
			"quizTitle": "Assessment",
			"courseName": "Course",
			"description": "Before you begin, we will guide you through a quick check to confirm your device and environment are ready for the assessment. This will only take a few minutes."
		},
		"referenceMaterial": {
			"description": "Your instructor has enabled reference material uploads for this assessment. You may upload one reference material and access it at any time during the test.",
			"uploadTitle": "Upload Your Material",
			"optional": "(Optional)",
			"uploadCaption": "Supported formats: PDF, JPG, JPEG, and PNG (max. 10 MB). Review your file before uploading, as changes cannot be made after the assessment starts.",
			"chooseFile": "Choose File",
			"toUpload": "to Upload"
		},
		"systemCheck": {
			"description": "Close unnecessary apps or tabs to avoid disruptions. You can continue, but performance may be affected.",
			"fail": "High Load",
			"pass": "Optimal",
			"systemResources": {
				"title": {
					"unstarted": "Checking System Performance",
					"failed": "Other Running Applications Are Impacting System Performance",
					"completed": "System Performance Check Passed"
				},
				"description": {
					"unstarted": "We are checking your device's speed and capacity to make sure the assessment runs smoothly.",
					"failed": "Verity detected applications that may impact performance. Close any unnecessary applications and run the check again.",
					"completed": "Your device meets the performance requirements for Verity. You are ready to continue with your assessment."
				},
				"guide": "Watch the video to learn how to improve your system performance for the assessment.",
				"guideTitle": "Need Help with Improving System Performance?",
				"videoTitle": "How to improve system performance",
				"cpuUsage": "CPU Usage",
				"cpuUsageTooltip": "The CPU is the part of your device that carries out tasks and instructions while programs are running.",
				"memoryUsage": "Memory Usage",
				"memoryUsageTooltip": "Memory is the part of your device that keeps apps and browser tabs running while you use them.",
				"reCheckButton": "Run System Check Again"
			},
			"connectionCheck": {
				"title": {
					"unstarted": "Checking Internet Connection",
					"failed": "Internet Connection Issues Detected",
					"completed": "Stable Internet Connection"
				},
				"description": {
					"unstarted": "We are checking your network speed and stability to prevent interruptions during your assessment.",
					"failed": "The upload speed of your internet does not meet the minimum requirement. Try moving closer to your Wi-Fi or disconnecting other devices on your network.",
					"completed": "Your internet speed meets the requirements to run the assessment smoothly."
				},
				"minimumUploadSpeedLabel": "Required Upload Speed",
				"uploadSpeedValue": "{{speed}} Mbps",
				"uploadSpeedLabel": "Your Upload Speed",
				"tryAgainButton": "Try Again"
			},
			"enableGeofence": {
				"title": {
					"unstarted": "Checking Location",
					"notInRadius": "Location Outside Geofence",
					"unknownLocation": "Location Not Detected",
					"completed": "Location Within Geofence"
				},
				"description": {
					"unstarted": "We are verifying if your current location is within the approved geofence for this assessment.",
					"notInRadius": "Your location is outside the approved geofence for this assessment. You can continue with the assessment.",
					"completed": "Your location is within the approved geofence for this assessment.",
					"noPermission": "Your location could not be detected. Please enable location access in your browser settings, then try again.",
					"unknown": "Your location could not be detected. Please enable location access in both your device and browser settings, then try again."
				},
				"guide": {
					"title": "Need Help with Enabling Location Access?",
					"description": "Watch the video to learn how to enable location access in your browser and device settings.",
					"video": "How to share location"
				},
				"tryAgainButton": "Try Again"
			},
			"ipAddressRange": {
				"title": {
					"unstarted": "Checking IP Address",
					"notInRange": "IP Address Not Allowed",
					"unknown": "IP Address Not Detected",
					"completed": "IP Address Within Allowed Range"
				},
				"description": {
					"unstarted": "We are verifying if your current IP address is within the approved range for this assessment.",
					"notInRange": "Your current network does not match the IP address range required for this assessment. Connect to an approved network, then try again.",
					"completed": "Your IP address is within the approved range for this assessment.",
					"unknown": "Your IP address could not be detected. Please check your network connection, then try again."
				},
				"tryAgainButton": "Run Check Again"
			}
		},
		"assessmentSetup": {
			"description": "We are checking your browser and screen setup to make sure your assessment is secure.",
			"managedGuestSessionCheck": {
				"title": {
					"unstarted": "Checking Device Account Status",
					"failed": "Device Account Status Not Verified",
					"completed": "Device Account Status Verified"
				},
				"description": {
					"unstarted": "We are checking your device to ensure that you are logged in with a managed guest session account.",
					"failed": "You are not logged in with the required managed guest session account. Please sign out of your device and log in using the guest session account provided by your institution.",
					"completed": "You are logged in using a managed guest session account."
				},
				"guideTitle": "Need Help Logging in with Managed Guest Session Account?",
				"guideDescription": "Watch the video to learn how to log in to your device using a managed guest session account.",
				"videoTitle": "How to log into a managed guest session account"
			},
			"incognitoCheck": {
				"title": {
					"unstarted": "Checking Incognito Mode",
					"failed": "Incognito Mode Not Enabled",
					"completed": "Incognito Mode Enabled"
				},
				"description": {
					"unstarted": "We are checking your browser setup to ensure incognito mode is enabled for the Verity Browser Extension.",
					"failed": "Incognito mode is not enabled for Verity Browser Extension. Please enable it and refresh the page to try again.",
					"completed": "Incognito mode is enabled for the Verity Browser Extension."
				},
				"guide": "Watch the video to learn how to enable incognito mode for the Verity Browser Extension.",
				"guideTitle": "Need Help with Enabling Incognito?",
				"videoTitle": "How to enable Incognito Mode",
				"tryAgain": "Try Again"
			},
			"oneScreenEnforcementMode": {
				"title": {
					"unstarted": "Checking Your Screen Setup",
					"failed": "Multiple Screens Detected",
					"completed": "Screen Setup Ready"
				},
				"description": {
					"unstarted": "We are checking your screen setup. Only one screen is allowed in this assessment.",
					"failed": "More than one screen was detected. Please unplug any additional monitors and try again.",
					"completed": "Your screen setup is ready for the assessment."
				}
			},
			"closeOpenTabs": {
				"title": {
					"unstarted": "Checking Browser Tabs",
					"failed": "Additional Tabs Detected",
					"completed": "All Additional Tabs Closed"
				},
				"description": {
					"unstarted": "We are checking your browser tabs to ensure no additional tabs are open.",
					"failed": "Some tabs are still open. Please close all additional tabs to continue.",
					"completed": "All additional tabs are closed. You will not be able to open new tabs during your assessment."
				},
				"closeAllTabsButton": "Close All Tabs"
			},
			"blockVirtualMachines": {
				"title": {
					"unstarted": "Checking for Virtual Machines",
					"failed": "Virtual Machine Detected",
					"completed": "No Virtual Machines Detected"
				},
				"description": {
					"unstarted": "We are checking for virtual machines to ensure your device is not running inside a virtual environment.",
					"failed": "Your device is currently running inside a virtual machine. Please close or disconnect it to continue.",
					"completed": "No virtual machines were detected."
				}
			},
			"recordApplicationsActivity": {
				"title": {
					"unstarted": "Checking Desktop Application Activities",
					"completed": "Monitoring Desktop Application"
				},
				"description": {
					"unstarted": "We are checking your device to ensure all applications are closed for your assessment.",
					"completed": "Your desktop application activities are now being monitored. Any time you open or close an application, it will be recorded."
				}
			},
			"applicationBlockMode": {
				"title": {
					"unstarted": "Checking for Blocked Applications",
					"failed": "Blocked Applications Detected",
					"completed": "All Blocked Applications Closed"
				},
				"description": {
					"unstarted": "We are checking for applications that must be closed before your assessment.",
					"failed": "The following applications are open. Please close them or click <b>Force Quit All Applications</b> to continue.",
					"completed": "All blocked applications are closed."
				},
				"forceQuitButton": "Force Quit All Applications",
				"guide": "If some applications do not close during force quit, you can use Task Manager to end them manually. Watch the video to learn how to close applications on your device using Task Manager.",
				"guideTitle": "Need Help with Closing Blocked Applications?",
				"videoTitle": "Close applications with Task Manager"
			},
			"sidePanelCheck": {
				"title": {
					"unstarted": "Checking Side Panel Activities",
					"failed": "Side Panel Activities Detected",
					"completed": "Monitoring Side Panel Activities"
				},
				"description": {
					"unstarted": "We are checking your browser to ensure the side panel is closed and in-browser AI tools or extensions are not being used.",
					"failed": "Your browser’s side panel is currently open. Please close it to continue your assessment.",
					"completed": "Your browser’s side panel activities are now being monitored. Any time you open or close the side panel, it will be recorded."
				}
			},
			"extensionBlockMode": {
				"title": {
					"unstarted": "Checking Browser Extension Activities",
					"failed": "Blocked Browser Extensions Detected",
					"completed": "All Blocked Browser Extensions Disabled"
				},
				"description": {
					"unstarted": "We are checking for browser extensions that must be disabled before your assessment.",
					"failedSingular": "The following browser extension is enabled. Please disable them in your Extension settings to continue.",
					"failedPlural": "The following browser extensions are enabled. Please disable them in your Extension settings to continue.",
					"completed": "All blocked browser extensions are disabled. You are ready to continue."
				},
				"guideDescription": "Watch the video to learn how to disable browser extensions for the assessment.",
				"guideTitle": "Need Help with Disabling Browser Extensions?",
				"videoTitle": "How to disable browser extensions",
				"disableExtensionAriaLabel": "Disable {{extensionName}}. Opens in a new tab."
			}
		},
		"deviceSetup": {
			"description": "We are setting up your {{devices}} to ensure your assessment is securely monitored.",
			"devices": {
				"camera": "camera",
				"microphone": "microphone",
				"screen": "screen"
			},
			"videoRecordingMode": {
				"title": {
					"unstarted": {
						"single": "Setting up Camera",
						"multiple": "Setting up Cameras"
					},
					"completed": {
						"single": "Camera Recording Started",
						"multiple": {
							"physical": "Cameras Connected",
							"mobile": "Primary camera ready — Continue to secondary camera"
						}
					},
					"noPermission": {
						"single": "Unable to Access Camera",
						"multiple": "Camera Permission Required"
					},
					"notFound": {
						"single": "Camera Not Found",
						"multiple": {
							"primary": "Primary Camera Not Found",
							"secondary": "Secondary Camera Not Found",
							"all": "Cameras Not Found"
						}
					},
					"deviceInUse": {
						"single": "Camera in Use",
						"multiple": {
							"primary": "Primary Camera in Use",
							"secondary": "Secondary Camera in Use",
							"all": "Cameras in Use"
						}
					},
					"unknown": {
						"single": "Camera Could Not Start",
						"multiple": {
							"primary": "Primary Camera Error",
							"secondary": "Secondary Camera Error",
							"all": "Connection Interrupted"
						}
					},
					"multipleErrors": "Camera Setup Issues Detected"
				},
				"description": {
					"unstarted": {
						"single": "We are setting up your camera. Your video will be recorded during the assessment.",
						"multiple": "We are connecting to your primary and secondary cameras. Your video from both sources will be recorded."
					},
					"completed": {
						"single": "Your camera is now recording. Take a quick look at the video preview to make sure it looks clear.",
						"multiple": {
							"physical": "Both cameras are now recording. Please check the previews to ensure your face and environment are clearly visible.",
							"mobile": "Your primary camera has connected successfully. The secondary camera will be set up in the next step during Secure Access."
						}
					},
					"noPermission": {
						"single": "You have not allowed camera access. Please enable it in your browser or device settings to continue.",
						"multiple": {
							"primary": "We don't have permission to access your primary camera. Please check your browser or device settings.",
							"secondary": "We don't have permission to access your secondary camera. Please check your browser or device settings.",
							"all": "You have not allowed camera access. Please enable permissions for both devices in your browser or device settings to continue."
						}
					},
					"notFound": {
						"single": "No video source was detected on your device. Please connect a camera to continue.",
						"multiple": {
							"primary": "We can't detect your Primary video source. Please ensure it is plugged in or re-select a device from the list.",
							"secondary": "We can't detect your Secondary video source. Please ensure it is plugged in or re-select a device from the list.",
							"all": "No video sources were detected on your device. Please connect your primary and secondary cameras to continue."
						}
					},
					"deviceInUse": {
						"single": "Your camera is currently being used by another application. Please close any applications using your camera and try again.",
						"multiple": {
							"primary": "Your Primary camera is being used by another application. Please close that app and try again.",
							"secondary": "Your Secondary camera is being used by another application. Please close that app and try again.",
							"all": "Your cameras are currently being used by another application. Please close any other programs that might be accessing your video and try again."
						}
					},
					"unknown": {
						"single": "We could not start your camera. Please reselect your video source or reconnect it to continue.",
						"multiple": {
							"any": "We couldn't start this video feed. Try re-selecting the source in the dropdown or reconnecting the hardware.",
							"all": "We lost the feed from both cameras. Please ensure they are securely plugged in and re-select them from the list."
						}
					},
					"multipleErrors": "We are unable to start your video feeds. Please resolve the specific issue for each camera to continue."
				},
				"chooseWebcam": "Video Source",
				"webcamNotFound": "No Video Source Detected",
				"webcamNotSelected": "Webcam has not been selected",
				"guideTitle": "Need Help with Setting Up Your Camera?",
				"guideDescription": "Watch the video to learn how to set up your camera for the assessment.",
				"videoTitle": "How to set up your camera",
				"selectWebcam": "Select Webcam",
				"tryAgain": "Try Again",
				"primaryCamera": "Primary Camera",
				"secondaryCamera": "Secondary Camera",
				"mobileCamera": "Use my mobile as a camera",
				"mobileSelected": {
					"title": "Mobile Device Selected",
					"description": "Mobile camera setup will be completed in the next step. Please continue with device setup."
				}
			},
			"secondaryVideoRecordingMode": {
				"guideTitle": "Need Help with Setting Up Your Secondary Camera?",
				"guideDescription": "Watch the video to learn how to set up your secondary camera for the assessment.",
				"videoTitle": "How to set up your secondary camera"
			},
			"audioRecordingMode": {
				"title": {
					"unstarted": "Setting up Microphone",
					"failed": "Microphone Not Detected",
					"completed": "Microphone Recording Started",
					"noPermission": "Unable to Access Microphone",
					"notFound": "Microphone Not Found",
					"deviceInUse": "Microphone in Use",
					"unknown": "Microphone Could Not Start"
				},
				"description": {
					"unstarted": "We are setting up your microphone. Your audio will be recorded during the assessment.",
					"failed": "Your audio device could not be detected. Please check to ensure your device is properly connected.",
					"completed": "Your microphone is now recording. Try speaking to test if the audio is working properly.",
					"noPermission": "You have not allowed microphone access for this browser. Please enable it in your browser settings to continue.",
					"notFound": "No audio source was detected on your device. Please connect a microphone to continue.",
					"deviceInUse": "Your microphone is currently being used by another application. Please close any applications using your microphone and try again.",
					"unknown": "We could not start your microphone. Please reselect your audio source or reconnect it to continue.",
					"noAudio": "We cannot detect any sound from your microphone. Try speaking again or select a different audio source to continue."
				},
				"chooseMicrophone": "Audio Source",
				"microphoneNotFound": "No Audio Source Detected",
				"guideTitle": "Need Help with Setting Up Your Microphone?",
				"guideDescription": "Watch the video to learn how to set up your microphone for the assessment.",
				"videoTitle": "How to set up your microphone",
				"selectMicrophone": "Select Microphone",
				"tryAgain": "Try Again"
			},
			"recordScreen": {
				"title": {
					"unstarted": "Setting Up Screen Recording",
					"failed": "Screen Recording Not Enabled",
					"completed": "Screen Recording Started"
				},
				"description": {
					"unstarted": "Screen recording is required for your assessment. Allow screen sharing and select your entire screen to share.",
					"failed": "Your screen could not be shared. Please select Entire Screen when sharing, and try again.",
					"completed": "Your screen is now being recorded for the assessment.",
					"failedMac": "You have not enabled screen recording for this browser. Please enable it in your system settings, and try again."
				},
				"tryAgain": "Try Again",
				"selectScreen": "Select Screen Source",
				"guideTitle": "Need Help with Screen Sharing?",
				"macGuide": "Watch the tutorial to learn how to enable screen recording on Apple devices.",
				"windowGuide": "Watch the video to learn how to set up screen sharing for Windows devices.",
				"videoTitle": "How to set up Screen Share"
			}
		},
		"roomScan": {
			"description": "We are verifying your testing environment to ensure the space is secure and that no unauthorized individuals are present.",
			"scanRoom": {
				"title": {
					"unstarted": "Take a Scan of Your Room",
					"started": "Room Scan in Progress",
					"failed": "Room Scan Not Completed",
					"completed": "Room Scan Completed"
				},
				"description": {
					"unstarted": "Slowly pan your laptop or webcam around the room to capture a 360-view of your surroundings, including the assessment-taking area.",
					"started": "Slowly pan your laptop or webcam around the room to capture a 360-view of your surroundings, including the assessment-taking area.",
					"failed": "Your room scan recording could not be uploaded. Please restart the room scan and try again.",
					"completed": "Your room scan is completed. Review your room scan recording before continuing."
				},
				"startRoomScan": "Start Scanning",
				"finish": "End",
				"retakeRoomScan": "Retake Room Scan",
				"successToast": "Your Room Scan recording has been uploaded successfully",
				"guide": "Watch the video to learn how to complete a room scan for your assessment.",
				"guideTitle": "Need Help with Room Scanning?",
				"videoTitle": "How to Perform a Room Scan",
				"stopRecordingAriaLabel": "Stop room scan recording"
			}
		},
		"verifyIdentity": {
			"signatureOnlyTitle": "Signature Check",
			"description": "We are verifying your identity by checking if your photos and signature match.",
			"idOnlyDescription": "We are verifying your identity by checking if your photos match.",
			"signatureOnlyDescription": "We are verifying your signature to ensure it is clear and can be used to confirm your identity.",
			"substep": {
				"idCard": "Scan ID Card",
				"faceVerification": "Take Your Photo",
				"signature": "Add Signature",
				"review": "Review Information",
				"completed": "Completed"
			},
			"idCard": {
				"title": "Take a Photo of Your ID Card",
				"description": "Align the front of your ID card to the center of the camera frame, then click Take Photo to continue.",
				"button": "Take Photo"
			},
			"faceVerification": {
				"title": "Take a Photo of Your Face",
				"description": "Align your face to the center of the camera frame, then click Take Photo to continue.",
				"button": "Take Photo"
			},
			"signature": {
				"title": {
					"draw": "Add Signature",
					"type": "Type Your Signature",
					"fail": "Signature Could Not Be Uploaded"
				},
				"description": {
					"draw": "Use your mouse or trackpad to draw your signature in the space provided.",
					"type": "Enter your first and last name. This will be used as your signature.",
					"fail": "Your signature could not be uploaded. Please try again."
				},
				"preferTyping": "Prefer typing? <a>Type your signature</a> instead.",
				"preferDraw": "Prefer drawing? <a>Draw your signature</a> instead.",
				"signaturePlaceholder": "Enter first and last name",
				"clear": "Clear",
				"drawSignaturePlaceholder": "Draw using your mouse or trackpad"
			},
			"reviewPhoto": {
				"attempts": "Attempt {{count}} of 3",
				"title": {
					"noAiTitle": "Review Information",
					"aiFailed": "Confirm Your Identity",
					"aiPass": "Identity Verified",
					"aiStarted": "Validating Your Identity"
				},
				"description": {
					"manualAll": "Please review your photo, ID card, and signature before continuing. If everything looks accurate, click Next to continue. If not, retake the relevant item before proceeding.",
					"failedStrict": "We could not confirm your identity this time. Retake your photo and ID card to make sure they are clear and consistent.",
					"failed": "We could not confirm your identity this time. Retake your photo and ID card to make sure they are clear and consistent.",
					"aiPass": "Your identity has been successfully verified. You are all set to continue.",
					"aiStarted": "We are verifying your face, ID photos, and signature. This may take a moment.",
					"aiStartedNoSig": "We are verifying your face and ID photos. This may take a moment.",
					"signatureOnly": "Review your signature to make sure it is clear.",
					"idOnly": "Review your photo and ID card to make sure they are clear and consistent."
				},
				"buttons": {
					"idCard": "Retake Photo",
					"faceVerification": "Retake Photo",
					"signature": "Update Signature",
					"retryBoth": "Retake Photos"
				},
				"labels": {
					"idCard": "ID",
					"faceVerification": "Face",
					"signature": "Signature"
				},
				"failTooltip": {
					"upload": {
						"idCard": "Your ID card photo could not be uploaded. Please retake your ID card photo and try again.",
						"faceVerification": "Your face photo could not be uploaded. Please retake your face photo and try again.",
						"signature": "Your signature could not be uploaded. Please update your signature and try again."
					},
					"ai": {
						"idCard": "Please retake your ID card photo to ensure it matches your face photo.",
						"faceVerification": "Please retake your photo to ensure it matches your ID card."
					}
				},
				"flags": {
					"bannerTitle": "Tips for a Successful Verification",
					"idCardInFace": "Remove your ID card from the face photo.",
					"generalPhone": "Remove all electronic devices from the photos.",
					"missingIdCard": "Make sure exactly one ID card is fully visible in the ID photo.",
					"missingFace": "Make sure each photo contains exactly one clear face.",
					"multipleIdCards": "Show only one ID card in the photo.",
					"doNotMatch": "Your face photo does not match the photo on your ID."
				},
				"typedSignature": "<b>Signature Name</b> {{signature}}",
				"ariaLabels": {
					"idCard": "Test-taker ID card",
					"faceVerification": "Test-taker photo",
					"signature": "Test-taker signature"
				}
			}
		},
		"mobileConnect": {
			"description": {
				"record": "We are setting up your mobile camera to provide a secondary view of your environment for secure monitoring.",
				"restrict": "We are setting up mobile device restrictions to ensure a secure testing environment.",
				"restrictAndRecord": "We are setting up your camera to ensure your assessment is securely monitored."
			},
			"restrictDevices": {
				"title": {
					"record": {
						"unstarted": "Setting up Mobile Camera for Recording",
						"completed": "Mobile Camera Recording Started"
					},
					"restrict": {
						"unstarted": "Setting up Mobile Device Restrictions",
						"completed": "Mobile Restriction Started"
					},
					"restrictAndRecord": {
						"unstarted": "Setting up Secure Access on your mobile device",
						"completed": "Mobile Camera and Restriction Started"
					}
				},
				"description": {
					"record": {
						"unstarted": "Please connect your mobile device to act as a secondary recording source for your assessment.",
						"completed": "Your mobile camera is now recording. Take a quick look at the video preview to make sure it looks clear."
					},
					"restrict": {
						"unstarted": "To ensure a secure testing environment, please follow the steps below to enable Guided Access on your mobile device.",
						"completed": "Your mobile device is now secured. You may continue with your assessment."
					},
					"restrictAndRecord": {
						"unstarted": "We are setting up mobile device restrictions for your assessment. Scan the QR code to enable Guided Access and complete mobile camera setup.",
						"completed": "Your mobile camera is now recording, and your device is secured for the assessment."
					}
				},
				"step": "Step {{number}}",
				"steps": {
					"download": "Download the Verity app.",
					"scan": {
						"started": {
							"restrict": "Scan the QR Code to link your mobile device.",
							"restrictAndRecord": "Scan the QR Code and setup mobile device as a camera.",
							"record": "Open the app and scan the QR code."
						},
						"completed": "Mobile device setup is complete."
					},
					"restrict": {
						"started": "Enable Guide Access on your mobile device.",
						"completed": "Guided Access is enabled."
					},
					"record": "Follow the instructions on your mobile device to finish setting up the secondary camera."
				},
				"scanQRCode": "Scan QR Code",
				"guideDescription": "Watch the video to learn how to turn on Guided Access for this restriction.",
				"guideTitle": "Need Help with Setting Up Mobile Device Restriction?",
				"videoTitle": "Setting up Mobile Device Restriction",
				"failToast": "Failed to start restricted device recording"
			}
		},
		"review": {
			"title": "All Set and Ready to Go!",
			"description": "Before starting your assessment, please review the information below.",
			"policyTitle": "How Your Information Is Used",
			"policyDescription": "Your privacy is important to us. Here is how your information may be used during the assessment:",
			"policy1": "YuJa Verity may record your screen, webcam, audio, and activity if required.",
			"policy2": "YuJa acts as a service provider and does not sell or monetize your data.",
			"institutionTitle": "Institution Policy",
			"institutionDescription": "Review <a>your institution's policy</a> for this proctored assessment.",
			"instituionPolicy": "Institution Policy",
			"policyAriaLabel": "Learn more about YuJa's privacy policy. Opens in a new tab.",
			"limitedActionsTitle": "Limited Actions",
			"limitedActionsDescription": "Once your assessment begins, these actions will be limited. Any suspicious activity will be flagged.",
			"installedExtensionsTitle": "View Installed Browser Extensions",
			"installedExtensionsDescription": "All browser extensions installed on your device will be visible to your instructor and proctor.",
			"allowedUrlsTitle": "Permitted Websites",
			"allowedUrlsDescription": "The following websites are permitted during this assessment.",
			"appliedLimits": {
				"disableRightClick": "Disable Right Click",
				"disableNewTab": "Disable New Tabs",
				"disableClipboardMode": "Disable Clipboard",
				"closeOpenTabs": "Close Open Tabs",
				"recordWebTraffic": "Record Web Traffic",
				"disableDownloadFiles": "Disable File Download",
				"disablePrinting": "Disable Printing",
				"hideOtherWindows": "Monitor Desktop Applications",
				"logInstalledExtensions": "View Installed Browser Extensions"
			}
		}
	},
	"supportModal": {
		"iframeAriaLabel": "Support Modal"
	},
	"subAccount": {
		"singular": {
			"canvas": "Canvas Account",
			"desire2learn": "D2L Brightspace Organization Unit",
			"moodle": "Moodle Category",
			"BlackboardLearn": "Blackboard Node",
			"default": "Sub-Account"
		},
		"plural": {
			"canvas": "Canvas Accounts",
			"desire2learn": "D2L Brightspace Organization Units",
			"moodle": "Moodle Categories",
			"BlackboardLearn": "Blackboard Nodes",
			"default": "Sub-Accounts"
		}
	},
	"quickSetupGuide": {
		"title": "Quick Setup Guide",
		"setupGuide": "Setup Guide",
		"minimize": "Minimize",
		"expand": "Expand",
		"close": "Close",
		"refresh": "Refresh",
		"bodyPrompt": "Please complete all required integration settings before proceeding.",
		"allComplete": "Verity setup is complete. Instructors can now create and deliver assessments with Verity ready to successfully proctor them. You can close this Quick Setup Guide.",
		"progressBarTitle": "Full Setup Progress",
		"progressBarLabel": "{{completed}} of {{total}} completed",
		"footerLink": "<a>YuJa Help Center</a>",
		"stepNumber": "Step {{number}}",
		"stepNumberProgress": "Step {{firstNum}} - Step {{lastNum}}",
		"collapseCompleted": "Collapse completed steps",
		"integrations": {
			"1p3": "LTI 1.3",
			"visualizer": "LMS Visualizer",
			"api": "LMS API",
			"profile": "Create a Proctoring Profile",
			"profileDesc": "Create a Proctoring Profile to simplify applying proctoring settings to assessments.",
			"profileButton": "Create Proctoring Profile",
			"extension": "Download Extension",
			"extensionDesc": "Download the Verity extension to enable proctoring controls directly in the web browser during assessments.",
			"extensionButton": "Download Verity Extension",
			"createAssessment": "Create An Assessment",
			"createAssessmentDesc": "Create a sample assessment to walk through the Verity instructor setup experience.",
			"createAssessmentButton": "Create Assessment",
			"takeAssessment": "Take An Assessment",
			"takeAssessmentDesc": "Complete the assessment as a student to experience the full Verity proctored assessment flow.",
			"takeAssessmentButton": "Take Assessment",
			"viewResults": "Review Proctoring Results",
			"viewResultsDesc": "Open the results to see any flagged behaviors captured during the assessment and understand what instructors will review.",
			"viewResultsButton": "View Results"
		},
		"stepProgress": "Step {{current}}/{{total}}",
		"create": {
			"checkboxTitle": "Add YuJa Verity Proctoring",
			"checkboxDescription": "Click the checkbox to add YuJa Verity Proctoring to your quiz.",
			"lmsSaveTitle": "Save Assessment",
			"editQuizSaveErrorTitle": "Error Adding Verity Proctoring",
			"editQuizSaveErrorDescription": "There was an error adding Verity Proctoring to your quiz. Please try again.",
			"editQuiz": {
				"title": "Modify Restrictions",
				"descriptionFallback": "Modify the settings, then click Confirm to apply Verity Proctoring to your quiz once you are done.",
				"methodDescription": "Select <b>Automated Proctoring</b> to continue.",
				"methodNext": "<b>Automated Proctoring</b> is selected. Click <b>Next</b> to continue.",
				"methodLiveCheckIn": "Select <b>Live Check In</b> to continue.",
				"methodLiveCheckInNext": "<b>Live Check In</b> is selected. Click <b>Next</b> to continue.",
				"methodFallback": "Choose a method and click <b>Next</b> to continue.",
				"profileDescription": "Choose a profile that uses the <b>Browser Extension</b> to continue.",
				"profileNext": "A <b>Browser Extension</b> profile is selected. Click <b>Next</b> to continue.",
				"profileBrowserDescription": "Choose a profile that uses <b>Web Browser</b> proctoring to continue.",
				"profileBrowserNext": "A <b>Web Browser</b> profile is selected. Click <b>Next</b> to continue.",
				"profileNoExtensionFallback": "Choose <b>custom configuration</b> to continue.",
				"profileNoExtensionNext": "Click <b>Next</b> to continue.",
				"profileFallback": "Choose a profile and click <b>Next</b> to continue.",
				"platformDescription": "Select <b>Browser Extension</b> to continue.",
				"platformNext": "<b>Browser Extension</b> is selected. Click <b>Next</b> to continue.",
				"platformBrowserDescription": "Select <b>Web Browser</b> to continue.",
				"platformBrowserNext": "<b>Web Browser</b> is selected. Click <b>Next</b> to continue.",
				"platformFallback": "Select a platform and click <b>Next</b> to continue",
				"configurationDescription": "Modify the remaining settings and proceed to the review step.",
				"reviewDescription": "Click <b>Confirm</b> to apply Verity Proctoring to your quiz once you are done."
			},
			"canvas": {
				"checkboxTitle": "Select YuJa Verity in Quiz Restrictions",
				"lmsSaveDescription": "Click <b>Save</b> to save your assessment.",
				"createQuizTitle": "Create New Quiz",
				"createQuizDescription": "Click <b>+Quiz/Survey</b> to create a new assessment.",
				"chooseQuizEngineTitle": "Select Quiz Engine",
				"chooseQuizEngineDescription": "Select <b>Classic Quizzes</b> to continue.",
				"quizEngineConfirmTitle": "Confirm Selection",
				"quizEngineConfirmDescription": "Click <b>Submit</b> to continue."
			},
			"d2l": {
				"createQuizTitle": "Create New Quiz",
				"createQuizDescription": "Click <b>New Quiz</b> to create a new assessment.",
				"lmsSaveDescription": "Click <b>Save and Close</b> to save your assessment."
			},
			"moodle": {
				"lmsInitialSaveTitle": "Save Assessment",
				"lmsInitialSaveDescription": "Click <b>Save and display</b> to save your assessment. YuJa Verity Proctoring will be available after saving.",
				"continueTitle": "Continue to Edit Assessment",
				"continueDescription": "Moodle is updating the gradebook. Click <b>Continue</b>.",
				"dropdownButtonTitle": "Open Quiz Options",
				"dropdownButtonTitleDescription": "Click the gear icon to open the quiz options.",
				"settingsTitle": "Edit Quiz Settings",
				"settingsDescription": "Click <b>Settings</b> to edit your assessment",
				"settingsDescription3p9": "Click <b>Edit Settings</b> to edit your assessment",
				"lmsSaveDescription": "Click <b>Save and display</b> to save your assessment."
			},
			"bbOriginal": {
				"fallbackCreateQuizTitle": "Create New Assessment",
				"fallbackCreateQuizDescription": "Click <b>Create</b> to create a new assessment.",
				"chooseQuizEngineTitle": "Select Assessment Type",
				"chooseQuizEngineDescription": "Select <b>Test</b> to continue.",
				"createQuizTitle": "Create New Quiz",
				"createQuizDescription": "Click <b>Create</b> to create a new assessment.",
				"initialQuizDetailsTitle": "Enter Quiz Details",
				"initialQuizDetailsDescription": "Enter any assessment details, then click <b>Submit</b> to continue.",
				"continueTitle": "Add Questions",
				"continueDescription": "Add any questions, then click <b>OK</b> to continue.",
				"selectCreatedQuizTitle": "Select Created Assessment",
				"selectCreatedQuizDescription": "Select your created assessment from the list, then click <b>Submit</b> to continue.",
				"lmsInitialSaveTitle": "Save Assessment",
				"lmsInitialSaveDescription": "Click <b>Submit</b> to save your assessment. YuJa Verity Proctoring will be available after saving.",
				"dropdownButtonTitle": "Open Quiz Options",
				"dropdownButtonTitleDescription": "Click the arrow to open the quiz options.",
				"settingsTitle": "Edit Test Options",
				"settingsDescription": "Click <b>Edit the Test Options</b> to edit your assessment",
				"lmsSaveDescription": "Click <b>Submit</b> to save your assessment."
			},
			"bbUltra": {
				"fallbackCreateQuizTitle": "Create New Content",
				"fallbackCreateQuizDescription": "Click the plus icon to create new content.",
				"createQuizTitle": "Create New Content",
				"createQuizDescription": "Click <b>Create</b> to create new content.",
				"chooseQuizEngineTitle": "Select Assessment Type",
				"chooseQuizEngineDescription": "Select <b>Test</b> to continue.",
				"openLmsQuizOptionsTitle": "Open Test Options",
				"openLmsQuizOptionsDescription": "Click the gear icon to open the test options.",
				"editLmsQuizTitle": "Edit Assessment Security",
				"editLmsQuizDescription": "Click <b>Configure proctoring settings</b> to edit proctoring settings.",
				"checkboxDescription": "Click <b>Turn on proctoring</b> to add proctoring to your assessment.",
				"initialQuizContinueTitle": "Edit YuJa Verity Proctoring Settings",
				"initialQuizContinueDescription": "Click <b>View YuJa Verity Settings</b> to edit your proctoring settings.",
				"initialSaveQuizTitle": "Save Proctoring Settings",
				"initialSaveQuizDescription": "Click <b>Save</b> to save proctoring settings.",
				"lmsSaveDescription": "Click <b>Save</b> to save your assessment."
			}
		},
		"take": {
			"canvas": {
				"previewButtonTitle": "Preview The Assessment",
				"previewButtonDescription": "Click <b>Preview</b> to open the assessment you just created and view it from a test-taker’s perspective.",
				"previewButtonYes": "Enable Preview to View The Assessment",
				"previewButtonYesDescription": "Click <b>Yes</b> to preview the assessment you just created from a test-taker’s perspective."
			},
			"d2l": {
				"dropdownButtonTitle": "Open Quiz Actions",
				"dropdownButtonTitleDescription": "Click the arrow to open the quiz actions menu.",
				"previewButtonTitle": "Preview The Assessment",
				"previewButtonDescription": "Click <b>Preview</b> to open the assessment you just created.",
				"startQuizButton": "Start Quiz",
				"startQuizButtonDescription": "Click <b>Start Quiz</b> to preview the assessment from a test-taker’s perspective.",
				"endPreviewButton": "Exit Preview",
				"endPreviewButtonDescription": "Click <b>Exit Preview</b> to exit the assessment preview and return to the quiz list."
			},
			"moodle": {
				"noQuestionTitle": "Add Questions to the Assessment",
				"noQuestionDescription": "Moodle requires at least one question before it can be previewed. Click <b>Add question</b> and come back when a question is added.",
				"noQuestionDescription3p9": "Moodle requires at least one question before it can be previewed. Click <b>Edit Quiz</b> and come back when a question is added.",
				"startQuizButton": "Start Quiz",
				"startQuizButtonDescription": "Click <b>Preview Quiz</b> to preview the assessment from a test-taker’s perspective.",
				"startQuizButtonDescription3p9": "Click <b>Attempt Quiz Now</b> to preview the assessment from a test-taker’s perspective."
			},
			"bbOriginal": {
				"clickQuizTitle": "Preview The Assessment",
				"clickQuizDescription": "Open the assessment you just created.",
				"startQuizButton": "Start Quiz",
				"startQuizButtonDescription": "Click <b>Begin</b> to preview the assessment from a test-taker’s perspective."
			},
			"bbUltra": {
				"noQuestionTitle": "Add Questions to the Assessment",
				"noQuestionDescription": "Blackboard Ultra requires at least one question before it can be previewed. Please add a question to continue.",
				"openLmsQuizOptionsTitle": "Open Visibility Menu",
				"openLmsQuizOptionsDescription": "Click the visibility icon to open the menu.",
				"makeVisibleTitle": "Make Assessment Visible",
				"makeVisibleDescription": "Please change the visibility to <b>Visible to Students</b> to preview the assessment.",
				"endPreviewTitle": "Return to the Content List",
				"endPreviewDescription": "Click to return to the content list.",
				"studentPreviewTitle": "Preview as a Student",
				"studentPreviewDescription": "Click <b>Student Preview</b> to preview as a student. Blackboard requires you to be a student to preview the assessment.",
				"confirmStudentPreviewTitle": "Confirm Student Preview",
				"confirmStudentPreviewDescription": "Click <b>Start Preview</b> to continue",
				"clickQuizTitle": "Preview The Assessment",
				"clickQuizDescription": "Open the assessment you just created.",
				"startQuizButton": "Start Quiz",
				"startQuizButtonDescription": "Click <b>Start Attempt</b> to preview the assessment from a test-taker’s perspective."
			}
		},
		"view": {
			"viewReportTitle": "View Proctoring Report",
			"viewReportDescription": "Click <b>View Results</b> to see the selected test-taker’s detailed proctoring report.",
			"viewResultsLmsTitle": "View Proctoring Results",
			"viewResultsLmsDescription": "Click <b>View Verity Results</b> to view results and proctoring activity for this assessment.",
			"moodle": {
				"finishLMSReview": "Finish Review",
				"finishLMSReviewDescription": "Click <b>Finish Review</b> to return to the quiz home page."
			},
			"bbOriginal": {
				"finishLMSReview": "Finish Review",
				"finishLMSReviewDescription": "Click <b>Ok</b> to return to Blackboard's review page.",
				"finishLMSReview2": "Finish Review",
				"finishLMSReview2Description": "Click <b>Ok</b> to return to the content home page.",
				"openQuizOptionsTitle": "Open Quiz Options",
				"openQuizOptionsDescription": "Click the arrow to open the quiz options.",
				"settingsTitle": "Edit Test Options",
				"settingsDescription": "Click <b>Edit the Test Options</b> to view the results."
			},
			"bbUltra": {
				"finishLMSReview": "Exit Student Preview",
				"finishLMSReviewDescription": "Click <b>Exit</b> to return to the content home page.",
				"openQuizOptionsTitle": "Open Assessment Settings",
				"openQuizOptionsDescription": "Click the assessment to open the settings.",
				"editLmsQuizTitle": "Open Proctoring Settings",
				"editLmsQuizDescription": "Click <b>Configure proctoring settings</b> to view the results."
			}
		}
	},
	"institutionSettings": {
		"information": {
			"name": {
				"header": "Institution Name",
				"description": "Your institution's name in the Verity API integration.",
				"placeholder": "Institution Name",
				"copyAriaLabel": "Copy Institution Name",
				"valid": "Institution name is valid",
				"empty": "Institution name cannot be empty",
				"used": "Institution name is already in use"
			},
			"product": {
				"header": "Product Type",
				"description": "The type of product your institution requires.",
				"verity": "Verity",
				"candidate": "Candidate AI",
				"AI": "{{name}} AI",
				"copyAriaLabel": "Copy Product Type"
			},
			"subdomain": {
				"header": "Custom Portal URL",
				"description": "The URL associated with your institution's Verity Platform.",
				"placeholder": "e.g., uniqueInstitutionIdentifier",
				"invalidVerity": "The URL must be of the format <b>uniqueInstitutionIdentifier.verity.yuja.com</b>. For example <b>yujaUniversity.verity.yuja.com</b>.",
				"invalidCandidate": "The URL must be of the format <b>uniqueInstitutionIdentifier.candidate.yuja.com</b>. For example <b>yujaUniversity.candidate.yuja.com</b>.",
				"valid": "URL is valid",
				"empty": "URL cannot be empty",
				"used": "URL is already in use",
				"copyAriaLabel": "Copy Custom Portal URL"
			},
			"yujaAccount": {
				"header": "YuJa Account",
				"description": "YuJa Account associated with the institution.",
				"placeholder": "Enter YuJa Account Name",
				"copyAriaLabel": "Copy YuJa Account"
			},
			"accountType": {
				"header": "Account Type",
				"description": "Your Verity Platform account: production, test, trial, or demo.",
				"production": "Production Account",
				"test": "Test Account",
				"trial": "Trial Account",
				"demo": "Demo Account",
				"copyAriaLabel": "Copy Account Type"
			},
			"platform": {
				"header": "LMS Type",
				"description": "The LMS integrated with the Verity Platform.",
				"BlackboardLearn": "Blackboard",
				"canvas": "Canvas",
				"desire2learn": "D2L Brightspace",
				"moodle": "Moodle",
				"none": "None",
				"disabled": "Institutions with the Candidate AI product type do not support platforms.",
				"copyAriaLabel": "Copy LMS Type"
			},
			"origin": {
				"header": "Domain",
				"description": "Your institution's base URL.",
				"placeholder": "Domain",
				"copyAriaLabel": "Copy Domain",
				"productDisabled": "Institutions with the Candidate AI product type do not support domains.",
				"platformDisabled": "You must choose an LMS Type to set the Domain.",
				"valid": "Domain is valid",
				"invalid": "Domain is invalid"
			},
			"institutionId": {
				"header": "Institution ID",
				"description": "The unique identifier for your Verity installation.",
				"copyAriaLabel": "Copy Institution ID",
				"disabledTooltip": "The Institution ID is automatically generated and cannot be modified."
			},
			"usage": {
				"hours": {
					"header": "{{methodName}} Hours Used",
					"description": "Number of hours used for {{methodName}} assessments.",
					"hint": "{{methodName}} hours are calculated based on the total time each test-taker spends in {{methodName}} sessions.",
					"copyAriaLabel": "Copy Hours Used"
				},
				"sessions": {
					"header": "{{methodName}} Sessions Used",
					"description": "Number of sessions used for {{methodName}} assessments.",
					"hint": "{{methodName}} sessions are calculated based on the total number of assessments completed by test-takers in {{methodName}} sessions.",
					"copyAriaLabel": "Copy Sessions Used"
				},
				"user": {
					"header": "{{methodName}} Test-Takers",
					"description": "Number of unique test-takers who completed {{methodName}} assessments.",
					"hint": "{{methodName}} test-takers are calculated based on the total number of unique test-takers who have completed assessments in {{methodName}} sessions.",
					"copyAriaLabel": "Copy Test-Takers"
				},
				"disabledTooltip": "Usage statistics are calculated based on completed assessments and cannot be modified."
			}
		}
	}
}
